/**
 * GENERATED FILE — Italian gender and plural lexicon. DO NOT EDIT BY HAND.
 *
 * Emitted by data-pipeline/run-romance.ts from the Wiktionary (wiktextract)
 * dump at kaikki.org. Data licence: CC BY-SA — see LICENSE-DATA.md.
 *
 * Only entries the rules get wrong are stored: gender where the ending
 * heuristic misleads (4359 of 59752 nouns), and plurals the
 * spelling rules do not produce (2447 of 51337).
 */

const GENDER_DATA = `abaca|m
abaptista|m
abba|m
abbagliaggine|f
abbassalingua|m
aberrazione|m
abiettitudine|f
abiogenesi|f
abiosi|f
abitagione|f
abitudine|f
abracadabra|m
abronemiasi|f
abugida|m
acantite|f
acantolisi|f
acantosi|f
acariasi|f
acaricida|m
acariosi|f
acaroide|f
accidiosaggine|f
accomunagione|f
accorataggine|f
acenaftalene|f
acetaldeide|f
acetammide|f
acetilasi|f
acetilcolinesterasi|f
acidolisi|f
acidosi|f
aciltransferasi|f
acioli|f
acne|f
acotiledone|f
acquaforte|f
acquapendente|f
acquavite|f
acredine|f
acrilammide|f
acrocianosi|f
acropoli|f
actinolite|f
actinomicosi|f
acucettore|f
acuzie|f
adangme|f
addebbiatura|m
addizionale|f
addormentasuocere|f
adenilciclasi|f
adenite|f
adenocarcinoma|m
adenoide|f
adenoipofisi|f
adenoma|m
adenosin|f
adenosintrifosfatasi|f
adibizione|m
adipocita|m
adipogenesi|f
adipolisi|f
adonide|f
adrenarca|m
adroma|m
advocacy|f
aerobiosi|f
aerocinesi|f
aeronave|f
aerotassi|f
afanite|f
aferesi|f
affezion|f
aforisma|m
afrihili|f
afrodite|f
afrolite|f
agamospecie|f
agave|f
aglaope|f
agniyoga|m
agranulocita|m
agranulocitosi|f
agroecosistema|m
agrosistema|m
agrostemma|m
agrostide|f
albedine|f
albedo|f
albergagione|f
albugine|f
albuminogenesi|f
alcalosi|f
alchilammide|f
alchilcarbossammide|f
alcol-deidrogenasi|f
aldeide|f
aldeideossidasi|f
aldolasi|f
alerione|f
alessandrite|f
aleurite|f
alice|f
alif|f
alinave|f
alisoide|f
alite|f
alitosi|f
all'erta|m
allantiasi|f
allantoide|f
allegagione|f
alleluia|m
alleluja|m
allergosi|f
allobiosi|f
alloccaggine|f
allucinosi|f
alluminite|f
alluminocopiapite|f
alluminosi|f
alluvione|f
aloe|f
alpaca|m
alpaga|m
alpe|f
altitudine|f
aluminite|f
alunite|f
alveolare|f
alzabandiera|m
alzavalvola|m
amadriade|f
amaide|f
amalgama|m
amamelide|f
amarilli|f
amarillide|f
amartoblastoma|m
amartoma|m
amaurosi|f
amazzone|f
amazzonite|f
ambage|f
ambiziosaggine|f
ambligonite|f
ambubaie|f
amebiasi|f
ameloblastoma|m
amelogenesi|f
amiantite|f
amichevole|f
amigdalite|f
amilasi|f
amiloglucosidasi|f
amiloidosi|f
aminogramma|m
aminotransferasi|f
amitosi|f
ammainabandiera|m
ammide|f
amminoaldeide|f
amminoglicoside|f
amminotransferasi|f
ammistione|f
ammonolisi|f
amniocentesi|f
amperora|m
amplitudine|f
anabasi|f
anabiosi|f
anacenosi|f
anaclasi|f
anacoenosi|f
anacoresi|f
anacoreta|m
anacrusi|f
anadiplosi|f
anaerobiosi|f
anafase|f
anafilassi|f
anafonesi|f
anaforesi|f
anagallide|f
anagenesi|f
anagiride|f
anagrafe|f
anagramma|m
analecta|m
analessi|f
analisi|f
anamnesi|f
anamorfosi|f
ananche|f
ananke|f
anaplasma|m
anaplasmosi|f
anaptissi|f
anasarca|m
anastilosi|f
anastomosi|f
anastrofe|f
anatema|m
anatessi|f
anchilosi|f
anchilostoma|m
anchilostomiasi|f
ancude|f
andalusite|f
andracne|f
andradite|f
andria|m
andrienne|f
androsace|f
anecumene|f
anemogramma|m
aneurisma|m
anfiartrosi|f
anfibolite|f
anfizione|m
angiocolite|f
angioedema|m
angiogenesi|f
angiogramma|m
angioite|f
angioma|m
angiosarcoma|m
anglocosmesi|f
anguillulosi|f
anidrasi|f
anidride|f
anidrosi|f
animadversione|m
animelle|f
anisaldeide|f
anisocitosi|f
ankerite|f
annessite|f
anoa|m
anortite|f
anostosi|f
antanaclasi|f
antarticite|f
antemide|f
antesi|f
antianafilassi|f
antiangina|m
antiansia|m
antibiogramma|m
antibiosi|f
antichitade|f
anticresi|f
antidorcade|f
antiflogosi|f
antifrasi|f
antillide|f
antilope|f
antimetabole|f
antinebbia|m
antinfluenzale|f
antiomega|m
antipallage|f
antipapa|m
antiperistalsi|f
antipiresi|f
antipolio|f
antiprisma|m
antiruggine|f
antisepsi|f
antisprue|f
antistrofe|f
antitesi|f
antiulcera|m
antogenesi|f
antoptosi|f
antracite|f
antracnosi|f
antracosi|f
antropogenesi|f
antroponosi|f
antropozoonosi|f
anubi|f
anuresi|f
aortite|f
apallage|f
apatite|f
ape|f
apeliota|m
apneusi|f
apocalisse|f
apocatastasi|f
apocope|f
apodissi|f
apodosi|f
apoenzima|m
apofisi|f
apofisite|f
apoftegma|m
apolisi|f
aponeurosi|f
aponevrosi|f
apoptosi|f
apoptosoma|m
aporema|m
aposimbiosi|f
aposiopesi|f
apostema|m
apostrofe|f
apotema|m
apoteosi|f
apozema|m
apozeugma|m
apozzema|m
app|f
appendice|f
appendicite|f
appendigonna|m
applique|f
appoggiatesta|m
apribocca|m
apripista|m
apriporta|m
aquagym|f
arabafenice|f
arachide|f
aracne|f
aracnoide|f
aracnoidite|f
aragonite|f
arameogramma|m
arammide|f
archè|f
archeobiosi|f
archiatra|m
archidiocesi|f
archimandrita|m
arcidiocesi|f
arciduca|m
arcocotangente|f
arcotangente|f
areogramma|m
areopagita|m
argentite|f
arginnide|f
argirite|f
argirodite|f
argirosi|f
argonauta|m
arie|f
aritenoide|f
armatrice|m
armerista|m
armocromia|m
aroma|m
aromatite|f
arpe|f
arpione|f
arsenopirite|f
arsi|f
arte|f
arteriogramma|m
arteriosclerosi|f
arterite|f
artrite|f
artrocentesi|f
artrodesi|f
artrogriposi|f
artrosi|f
asbestosi|f
ascesi|f
ascite|f
asciugabiancheria|m
asciugaggine|f
asclepiade|f
asepsi|f
asiarca|m
asinaggine|f
aspergillosi|f
aspergine|f
aspraggine|f
asse|f
assioma|m
assione|m
assise|f
assonema|m
assoplasma|m
asteatosi|f
astrocita|m
astronave|f
astrusaggine|f
ateroma|m
ateromatosi|f
aterosclerosi|f
atetosi|f
atmabodha|m
attinomicosi|f
attitudine|f
audience|f
audiogramma|m
audioprotesi|f
auge|f
augite|f
augustalie|f
auletride|f
auricuprite|f
auriga|m
austerity|f
autoanalisi|f
autobotte|f
autocamionale|f
autocatalisi|f
autocinema|m
autoclasi|f
autoclave|f
autocombustione|f
autoconvinzione|m
autoctisi|f
autodiagnosi|f
autodigestione|f
autofagocitosi|f
autofagolisosoma|m
autofagosoma|m
autogenesi|f
autogestione|f
autogru|f
autogrù|f
autoindagine|f
autoipnosi|f
autolisi|f
autolisosoma|m
automa|m
automobile|f
automostra|m
autopilota|m
autopoiesi|f
autoprotolisi|f
autoradio|f
autoreggente|f
autorespiratore|f
autorete|f
autoribaltabile|f
autoroulotte|f
autosoma|m
autospeaker|f
autosuggestione|f
autoturboreattore|f
avana|m
avance|f
avatara|m
aversitade|f
aviosuperficie|f
avitaminosi|f
avventataggine|f
aymara|m
azzurrite|f
babele|f
babirussa|m
baccante|f
bachelite|f
bacillosi|f
bagarre|f
bagnasciuga|m
bagnomaria|m
bagnoschiuma|m
balanite|f
balanopostite|f
balboa|m
balbuzie|f
balilla|m
balistite|f
balordaggine|f
bancoposta|m
bangla|m
banjar|f
bar-tabaccheria|m
barabba|m
baraccopoli|f
barasinga|m
barbarie|f
barbera|m
bariogenesi|f
barite|f
barnabita|m
barogramma|m
barracuda|m
barrique|f
bas-bleu|f
base|f
bassacorte|f
bassotuba|m
bastardaggine|f
batolite|f
battericida|m
batteriolisi|f
batteriostasi|f
battilana|m
battimazza|m
battipista|m
battiscopa|m
battismo|f
battistrada|m
bauxite|f
bdellio|f
be|f
beatitudine|f
becce|f
bellezze|f
beltade|f
beltate|f
bentonite|f
benzaldeide|f
bepridile|f
berberide|f
berilliosi|f
bermuda|m
bet|f
betalattamasi|f
bi|f
biade|f
bici|f
bidonville|f
bieltate|f
biennale|f
bifamiliare|f
bike|f
bilabiale|f
bile|f
bilharziosi|f
biltade|f
biltate|f
bimbominkia|m
biocenosi|f
bioerma|m
biofotogenesi|f
biofotolisi|f
biogenesi|f
bioherma|m
bioinsetticida|m
biolisi|f
bioma|m
biomimesi|f
biopesticida|m
bioprotesi|f
bioregione|f
biosatellite|f
biosintesi|f
biosistema|m
biotite|f
bipiramide|f
birbantaggine|f
bireme|f
biro|f
bischeraggine|f
bisecante|f
bislama|m
bismutinite|f
bisque|f
bissinosi|f
blague|f
blastocisti|f
blastoderma|m
blastogenesi|f
blastoma|m
blastomicosi|f
blaugrana|m
blefarite|f
blefaroptosi|f
boccanera|m
boccascena|m
boce|f
bocia|m
boia|m
bolivianite|f
bolsaggine|f
bolsedine|f
boma|m
boragine|f
borea|m
borgogna|m
borraggine|f
borragine|f
borsite|f
bostrice|m
botte|f
boutade|f
boutique|f
boxe|f
bra|m
brace|f
brache|f
brage|f
braghe|f
brambilla|m
bricconaggine|f
brighella|m
brioche|f
broche|f
brochure|f
bromidrosi|f
bronchiolite|f
bronchite|f
broncoalveolite|f
broncogramma|m
broncopleurite|f
broncopolmonite|f
broncostenosi|f
brucellosi|f
brunice|f
buaggine|f
bucalettere|f
buffonaggine|f
bugiardaggine|f
bulè|f
buleuta|m
buonafede|f
bure|f
busiate|f
buttasella|m
buvette|f
bwana|m
ca|m
ca'|f
cablogramma|m
cabrio|f
cabriolet|f
caca|m
cacatoa|m
cacatua|m
cacciafebbre|f
cacciapalla|m
cache|f
caciocappella|m
cafonaggine|f
cagione|f
calatide|f
calaverite|f
calcantite|f
calcarenite|f
calce|f
calcinosi|f
calcio-balilla|m
calciobalilla|m
calciocianammide|f
calciopoli|f
calciosoma|m
calcite|f
calcocite|f
calcolosi|f
calcopirite|f
calende|f
calicosi|f
caligine|f
calligramma|m
calliope|f
calorigenesi|f
calosoma|m
calugine|f
calvizie|f
cambiale|f
cambiatensione|m
camionabile|f
camionale|f
cancerogenesi|f
candidiasi|f
candidosi|f
canizie|f
cantaride|f
canzon|f
canzone|f
caolinite|f
capibara|m
capoarma|m
capocorda|m
capocronaca|m
capodopera|m
capolettera|m
capolinea|m
capomissione|m
caponaggine|f
capopagina|m
caporetto|f
caporonda|m
caposcala|m
capote|f
capotesta|m
capruggine|f
carabba|m
carbamide|f
carbammide|f
carbocaina|m
carbodinamite|f
carbonatite|f
carbonatoapatite|f
carbossammide|f
carbossichinasi|f
carbossilasi|f
carbossipeptidasi|f
carcinogenesi|f
carcinoma|m
carcinosi|f
card|f
cardiocentesi|f
cardiocita|m
cardiogramma|m
cardioide|f
cardiomiocita|m
cardionevrosi|f
cardiopalma|m
cardiosclerosi|f
cardiostenosi|f
cardite|f
cardone|f
cariatide|f
caricabatteria|m
carice|f
carie|f
cariocinesi|f
carioclasi|f
cariogramma|m
carioplasma|m
carioressi|f
cariosside|f
carisma|m
carme|f
carnagione|f
carne|f
carotide|f
carovita|m
carrozzabile|f
cartacarbone|f
cartevalori|f
cartilagine|f
cartogramma|m
casabase|f
casaforte|f
casalinghitudine|f
casamobile|f
casatorre|f
caspasi|f
cassaforte|f
casside|f
cassiterite|f
castronaggine|f
catabasi|f
catabolita|m
cataclasi|f
cataclisma|m
catacresi|f
cataforesi|f
catalasi|f
catalessi|f
catalisi|f
cataplasma|m
cataptosi|f
catarsi|f
catastrofe|f
catechesi|f
catenoide|f
cattedrale|f
causale|f
causerie|f
causeuse|f
cavalcaferrovia|m
cavalcavia|m
cavapunti|f
cavedine|f
ce|f
cedrata|m
cela|m
celere|f
celestite|f
cellulasi|f
cellulite|f
celluloide|f
celoma|m
celsitudine|f
celta|m
cementite|f
cenere|f
cenestesi|f
cenobiarca|m
cenobita|m
cenocita|m
cenosi|f
centesi|f
centofoglie|f
centomila|m
centrale|f
centrodestra|m
centrosinistra|m
centrosoma|m
centrotavola|m
ceramiche|f
ceraste|f
cerere|f
ceroidolipofuscinosi|f
cerussite|f
cervicale|f
cervice|f
cervicite|f
cesoie|f
cete|f
chance|f
chea|m
cheesecake|f
cheilite|f
chemio|f
chemioantibioticoprofilassi|f
chemiogenesi|f
chemiosintesi|f
chemiotassi|f
chemosi|f
chemotassi|f
cheratinasi|f
cheratinocita|m
cheratite|f
cheratocongiuntivite|f
cheratolisi|f
cheratoprotesi|f
cheratosi|f
cherema|m
chetogenesi|f
chiasma|m
chiave|f
chiliarca|m
chilobase|f
chilovattora|m
chilowattora|m
chinetosi|f
chininogenasi|f
chiroprassi|f
chitidriomicosi|f
chitinasi|f
chiudilettera|m
chiudiporta|m
cianamide|f
cianammide|f
cianite|f
cianosi|f
cicadide|f
ciclasi|f
ciclocampestre|f
cicloesimide|f
ciclogenesi|f
cicloide|f
ciclonite|f
ciclossigenasi|f
ciclotema|m
cifoscoliosi|f
cifosi|f
cilindrite|f
cimanalisi|f
cimice|f
cimoanalisi|f
cinasi|f
cinedramma|m
cinema|m
cinerite|f
cinetosi|f
cinipe|f
cinnabarite|f
cinquereme|f
circe|f
circolare|f
ciriole|f
cirrosi|f
cissoide|f
ciste|f
cisti|f
cisticercosi|f
cistide|f
cistite|f
cistoadenoma|m
cistogramma|m
cistoma|m
cistopielite|f
citate|f
citicinesi|f
citoaferesi|f
citochinesi|f
citocinesi|f
citoclasi|f
citocromoossidasi|f
citocromossidasi|f
citode|f
citodieresi|f
citofagocitosi|f
citofaringe|f
citoidrolisi|f
citoistogenesi|f
citolisi|f
citomorfosi|f
citopessi|f
citoplasma|m
citopoiesi|f
citoprognosi|f
citosoma|m
citostasi|f
citotassi|f
citronette|f
citrullaggine|f
città-stato|f
cittade|f
city|f
ciucaggine|f
cladogramma|m
clamide|f
claque|f
classe|f
clearance|f
clematide|f
clima|m
clisma|m
clitocibe|f
cloasma|m
cloche|f
cloracne|f
clorargirite|f
clorite|f
clorobenzaldeide|f
clorocalcite|f
clorofenicite|f
cloromagnesite|f
cloromenite|f
clorope|f
clorosi|f
clorothionite|f
cloroxifite|f
clotoide|f
clune|f
coagulasi|f
coanozoa|m
cobaltocalcite|f
cobra|m
coccidioidomicosi|f
coccidiosi|f
cocciutaggine|f
codione|f
coenzima|m
cogestione|f
cogia|m
coitarca|m
colangiocarcinoma|m
colangite|f
colapasta|m
colatitudine|f
colecisti|f
colecistite|f
coledocite|f
colelitiasi|f
colera|m
colestasi|f
colf|f
colibacillosi|f
colite|f
collagenasi|f
collenchima|m
coloquintide|f
coltre|f
columbite|f
coma|m
comare|f
combine|f
combustione|f
comma|m
commistione|f
compage|f
compagine|f
comunale|f
comunione|f
concattedrale|f
concezionista|m
concione|f
conclavista|m
condiloma|m
condivisibilità|m
condizion|f
condrite|f
condrocita|m
condrogenesi|f
condroma|m
condrosarcoma|m
congerie|f
congestione|f
congiuntivite|f
coniugatione|f
conjugatione|f
connescione|f
connessone|f
connettivite|f
consolle|f
consonante|f
consuetudine|f
contafiletti|f
contraltista|m
controabside|f
controanalisi|f
controchiave|f
controdote|f
controfase|f
controfune|f
controimmagine|f
controllista|m
controparte|f
convalle|f
convertasi|f
convertibile|f
coorte|f
copaive|f
copincolla|m
coppapasta|m
copricanna|m
copricatena|m
coprifiamma|m
coprimacchia|m
coprimacchina|m
copripresa|m
copriruota|m
coprisella|m
copritastiera|m
copritavola|m
copriteiera|m
copritovaglia|m
coprivettura|m
coprostasi|f
coque|f
corale|f
corderite|f
cordierite|f
coridale|f
corioretinite|f
corista|m
cornice|f
coroide|f
coroidite|f
coronide|f
corte|f
corvè|f
cosecante|f
cosinusoide|f
cosmesi|f
cosmonave|f
cosmopoli|f
cosmorama|m
cospirazionista|m
costante|f
cotangente|f
cote|f
coturnice|f
coxite|f
crambe|f
crampone|f
crasi|f
cravache|f
creatinchinasi|f
creatinfosfochinasi|f
credenziale|f
crepapelle|f
crepidoma|m
cricoide|f
criogenesi|f
criolite|f
criptococcosi|f
criptogramma|m
criptospecie|f
criptosporidiosi|f
crisalide|f
crisi|f
crisiasi|f
crisma|m
cristallogenesi|f
cristiania|m
crittanalisi|f
crittoanalisi|f
crittogramma|m
croce|f
crocevia|m
crocoite|f
cromatogramma|m
cromite|f
cromonema|m
cromosoma|m
cronema|m
crono|f
cronogramma|m
cronoprogramma|m
cronospecie|f
cronosquadre|f
cronotassi|f
crooksite|f
cruciverba|m
crudeltade|f
cubozoa|m
cudduredde|f
cumenda|m
cummingtonite|f
cunetta|m
cuprobismutite|f
curiosaggine|f
curtis|f
curtosi|f
cuspide|f
cute|f
cyclette|f
daboia|m
dacrioadenite|f
dacriocisti|f
dacriocistite|f
dacrioma|m
dada|m
dafne|f
dalmata|m
dape|f
dappocaggine|f
datolite|f
dattilogramma|m
deacetilasi|f
deamidasi|f
deaminasi|f
deb|f
débauche|f
decade|f
decagramma|m
decapottabile|f
decappottabile|f
decarbossilasi|f
decauville|f
decigramma|m
decompressione|m
decongestione|f
deculturazione|m
decusse|f
defaillance|f
défaillance|f
definitione|f
deflemmazione|m
deidrasi|f
deidratasi|f
deidrogenasi|f
deissi|f
deitade|f
deitate|f
delineazione|m
deliquere|f
delta|m
demetilasi|f
dendrita|m
dendrogramma|m
dentale|f
dentinogenesi|f
dependance|f
dépendance|f
depravazione|m
derma|m
dermatite|f
dermatofita|m
dermatofitosi|f
dermatomicosi|f
dermatomiosite|f
dermatosclerosi|f
dermatosi|f
dermite|f
dermocosmesi|f
dermoide|f
desiderata|m
desinapsi|f
desmosoma|m
destrinasi|f
desuetudine|f
detossificante|f
deuterostoma|m
dharma|m
di|f
diacinesi|f
diacitosi|f
diaclasi|f
diade|f
diadema|m
diafisi|f
diaforesi|f
diaframma|m
diagnosi|f
diagramma|m
dialefe|f
dialisi|f
diamide|f
diammide|f
diapedesi|f
diartrosi|f
diastasi|f
diastema|m
diastole|f
diatesi|f
dicotiledone|f
diegesi|f
dieresi|f
dietilammide|f
diffusone|f
difosfatasi|f
difosfochinasi|f
difosfotrasferasi|f
difterite|f
digamma|m
digestione|f
digitale|f
digramma|m
dilemma|m
dimane|f
dimetilacetammide|f
dimetilformammide|f
dinamite|f
dinamo|f
dinasta|m
diocesi|f
diopside|f
diorama|m
diorite|f
dipendente|f
dipeptidasi|f
diploma|m
directory|f
disaccaridasi|f
discissore|f
discriminante|f
disegnatrice|m
disinibizione|m
dismorfosi|f
dismutasi|f
disodontiasi|f
disontogenesi|f
disostosi|f
disposizion|f
disprosia|m
dissuetudine|f
distoma|m
disunione|f
dittiosoma|m
diuresi|f
divanista|m
diverticolite|f
diverticolosi|f
dizionarite|f
docciaschiuma|m
dogma|m
dolcevita|m
dolciera|m
dolomite|f
dominante|f
dopobarba|m
dopoborsa|m
dopocena|m
dopogara|m
dopoguerra|m
dopopartita|m
doposcuola|m
dormiveglia|m
dose|f
dossografia|m
dote|f
dreadnought|f
drepanocitosi|f
driade|f
duca|m
dulosi|f
dunite|f
duodenite|f
e|f
ebanite|f
ebetaggine|f
ebetudine|f
ecatombe|f
eccezion|f
ecchimosi|f
ecclissi|f
ecco|f
ecdisi|f
ecfrasi|f
echinoderma|m
ecista|m
eclisse|f
eco|f
ecocardiogramma|m
ecocatastrofe|f
ecoclima|m
ecogramma|m
ecopelle|f
ecoregione|f
ecosistema|m
ecostrage|f
ecpirosi|f
ectoderma|m
ectoparassita|m
ectoplasma|m
ecumene|f
eczema|m
edema|m
efelide|f
efemeride|f
effemeride|f
effige|f
effigie|f
eftalita|m
egritudine|f
egualitade|f
elamita|m
elastasi|f
elbaite|f
eleçione|f
elefantiasi|f
elementari|f
elettroanalisi|f
elettrocardiogramma|m
elettrodecantatore|f
elettrodialisi|f
elettroencefalogramma|m
elettroferogramma|m
elettroforesi|f
elettrogenesi|f
elettrolisi|f
elettrolita|m
elettromiogramma|m
elettronarcosi|f
elettroosmosi|f
elettrosintesi|f
elettrosmosi|f
elettrostenolisi|f
elezïone|f
elicasi|f
eliogramma|m
eliotassi|f
elisuperficie|f
élite|f
elle|f
ellisse|f
ellissi|f
ellittocitosi|f
elminta|m
elmintiasi|f
elminticida|m
eloderma|m
emaferesi|f
emangioma|m
ematemesi|f
ematite|f
ematoma|m
ematopoiesi|f
ematosi|f
emblema|m
emeritrine|f
emerocallide|f
emesi|f
emide|f
emidesmosoma|m
emimorfite|f
emiparassita|m
emiparesi|f
emittente|f
emoangioma|m
emoblastoma|m
emoceloma|m
emocianine|f
emocromatosi|f
emodialisi|f
emogasanalisi|f
emolisi|f
emopessina|m
emopoiesi|f
emorroide|f
emorroidi|f
emosiderosi|f
emostasi|f
emotisi|f
emottisi|f
emperipolesi|f
empetigine|f
empiema|m
enantema|m
enartrosi|f
encefalite|f
encefalogramma|m
encefalomielite|f
enclave|f
enclisi|f
encomiasta|m
encondroma|m
encopresi|f
endiade|f
endocardite|f
endocitosi|f
endoderma|m
endolinfa|m
endolisosoma|m
endometriosi|f
endometrite|f
endomitosi|f
endonucleasi|f
endoparassita|m
endopeptidasi|f
endoplasma|m
endoprotesi|f
endosimbiosi|f
endosmosi|f
endosoma|m
endosperma|m
endotelioma|m
enfasi|f
enfiagione|f
enfisema|m
enfiteusi|f
engramma|m
enigma|m
enimma|m
enneade|f
enneagramma|m
enomotarca|m
enstatite|f
entactina|m
entandrofragma|m
entasi|f
enterite|f
enterochinasi|f
enterocita|m
enteroclisi|f
enteroclisma|m
enterocolite|f
enteroglucagone|f
enteroptosi|f
entesi|f
entesite|f
entimema|m
entraineuse|f
entroterra|m
enuresi|f
enzima|m
enzimolisi|f
epanadiplosi|f
epanalessi|f
epanastrofe|f
eparca|m
epatite|f
epatocarcinoma|m
epatonefrite|f
epatosi|f
epentesi|f
epesegesi|f
epibiosi|f
epicardite|f
epicherema|m
epicicloide|f
epiclesi|f
epicondilite|f
epicrasi|f
epidermide|f
epidermolisi|f
epididimite|f
epifisi|f
epifisiolisi|f
epifonema|m
epifragma|m
epiframma|m
epifrasi|f
epigenoma|m
epiglottidale|f
epiglottide|f
epigrafe|f
epigramma|m
epimagma|m
epirrema|m
episclerite|f
episinalefe|f
episoma|m
episperma|m
epistasi|f
epistassi|f
epistrofe|f
epitelioma|m
epitesi|f
epitome|f
epulide|f
equipe|f
erbe|f
erbette|f
erbicida|m
eredolue|f
eremacausi|f
ergastoplasma|m
eritema|m
eritrasma|m
eritrite|f
eritroblastosi|f
eritrocita|m
eritrocitosi|f
eritrofagocitosi|f
eritrogenesi|f
eritrolisi|f
eritropoiesi|f
erre|f
erzya|m
esagramma|m
esaidrite|f
esaidroborite|f
esantema|m
esapoli|f
esarca|m
esaustione|f
escalation|f
esegesi|f
esequie|f
esicasta|m
esitamento|f
esochinasi|f
esocitosi|f
esoderma|m
esofagite|f
esogenesi|f
esonucleasi|f
esopeptidasi|f
esopianeta|m
esosoma|m
esostosi|f
esotrasferasi|f
espadrillas|f
espediente|f
essonite|f
estasi|f
estate|f
esterasi|f
estrasistole|f
estrusoma|m
eta|m
etade|f
etate|f
eterocariosi|f
eterocromosoma|m
eterofagosoma|m
eterogenesi|f
eterolisi|f
eteromorfosi|f
eterosi|f
eterosoma|m
etiopatogenesi|f
etnoarte|f
etospecie|f
etra|m
eucariota|m
euregione|f
euroregione|f
eussenite|f
euterpe|f
euxenite|f
evangelista|m
evaporite|f
evolvente|f
evviva|m
excerpta|m
exeresi|f
expertise|f
exsecante|f
extra|m
extranet|f
extrasistole|f
eziopatogenesi|f
f***|f
fa|m
face|f
faesite|f
fagocita|m
fagocitosi|f
fagolisosoma|m
fagosoma|m
falange|f
falce|f
falsettista|m
fame|f
familiare|f
fanciullaggine|f
fannulla|m
fannullaggine|f
fantasma|m
fantasticaggine|f
faringite|f
faringomicosi|f
faringotonsillite|f
farragine|f
fasce|f
fasciale|f
fascite|f
fase|f
fastidiosaggine|f
fattispecie|f
fauce|f
fauci|f
fayalite|f
fazion|f
febbre|f
fecaloma|m
feci|f
fede|f
felce|f
fellatio|f
fellema|m
felloderma|m
fenacite|f
fendinebbia|m
fenice|f
feocromocitoma|m
feoficee|f
feralie|f
fermacravatta|m
fermaporta|m
fermoposta|m
ferrite|f
ferrochelatasi|f
fiammelle|f
fibrinolisi|f
fibroma|m
fibrosarcoma|m
fibrosi|f
fiche|f
ficodindia|m
fienagione|f
figaggine|f
filariasi|f
filariosi|f
filiale|f
fillotassi|f
filogenesi|f
filosofema|m
filtropressa|m
fimosi|f
fin|f
fine-settimana|m
finecorsa|m
finesettimana|m
finitudine|f
fintaggine|f
fitocenosi|f
fitoclima|m
fitocosmesi|f
fitogenesi|f
fitoregolatore|f
flavedine|f
flavedo|f
flavizie|f
flebite|f
flebo|f
fleboclisi|f
flebotrombosi|f
floema|m
flogopite|f
flogosi|f
floribunda|m
fluorannite|f
fluorapatite|f
fluorapofillite|f
fluorcafite|f
fluorite|f
fluoroapatite|f
fluoroprofilassi|f
fluorosi|f
fluorvesuvianite|f
foce|f
folade|f
folgorite|f
follicolite|f
fondoschiena|m
fondotinta|m
fonema|m
fonocardiogramma|m
fonogramma|m
fonolite|f
fonosintassi|f
fonotassi|f
forapaglia|m
forassite|f
forbice|f
forbici|f
formaldeide|f
formante|f
fornace|f
forsennataggine|f
forsterite|f
foruncolosi|f
fosfatasi|f
fosfodiesterasi|f
fosfofruttochinasi|f
fosfoglucomutasi|f
fosfolipasi|f
fosforilasi|f
fosforite|f
fosfotransferasi|f
foto|f
fotocatalisi|f
fotocheratite|f
fotocomposizione|m
fotocorrente|f
fotodermatite|f
fotodermatosi|f
fotoforesi|f
fotogenesi|f
fotogramma|m
fotoliasi|f
fotolisi|f
fotosintesi|f
fotosistema|m
fototermolisi|f
fra|m
frase|f
frattaglie|f
fregagione|f
frette|f
friendzone|f
frociaggine|f
frode|f
fronde|f
frutticino|f
fruttochinasi|f
ftalammide|f
ftalimmide|f
ftanite|f
ftiriasi|f
fuchsite|f
fuliggine|f
fumarasi|f
fune|f
fungicida|m
funicolare|f
funicolite|f
funicolocentesi|f
fuoriborsa|m
fuorionda|m
fuoripagina|m
fuoripista|m
fuoriprogramma|m
fuoriquota|m
fuoriserie|f
fuoristrada|m
furfantaggine|f
fusaggine|f
gaffe|f
gagate|f
gaglioffaggine|f
galalite|f
galattopoiesi|f
galoche|f
gambesecche|f
gametocita|m
gametogenesi|f
gang|f
ganglioma|m
gangliosidosi|f
garçonnière|f
gargouille|f
gastrite|f
gastroduodenite|f
gastroenterite|f
gastroenterocolite|f
gastroepatite|f
gastroesofagite|f
gastrolusi|f
gastropessi|f
gattinara|m
gaufre|f
gaytudine|f
gelatinasi|f
genesi|f
gengivite|f
genoma|m
gente|f
geobiocenosi|f
geocinesi|f
geocronometria|m
geomateriale|f
geoportale|f
geosinclinale|f
gerarca|m
gerboa|m
geremiade|f
germicida|m
germoplasma|m
gestante|f
gestione|f
gestosi|f
gettonista|m
ghettine|f
gi|f
giadeite|f
gianduia|m
gianduja|m
gigawattora|m
gihad|f
ginnasiarca|m
ginogenesi|f
gioventude|f
gioventudine|f
gioventute|f
girasi|f
giropilota|m
girovita|m
giuda|m
giugulare|f
giunone|f
glacette|f
glaucoma|m
glene|f
glenoide|f
gliceraldeide|f
glicogenasi|f
glicogenofosforilasi|f
glicogenolisi|f
glicogenosi|f
glicogenosintesi|f
glicolammide|f
glicolide|f
glicolipidosi|f
glicolisi|f
glicosidasi|f
glicosilasi|f
glicosoma|m
glioblastoma|m
glioma|m
gliosi|f
gliossisoma|m
glomerulonefrite|f
gloriette|f
glossema|m
glossite|f
glossopoiesi|f
glottidale|f
glottide|f
glucanasi|f
glucoamilasi|f
gluconeogenesi|f
glucosidasi|f
glutaminasi|f
glutamminasi|f
gnosi|f
gocciol|f
goffaggine|f
golfara|m
golia|m
gomitiera|m
gommina|m
gonade|f
gonartrite|f
gondolone|f
gonfosi|f
gorgone|f
gorgonzola|m
gorilla|m
gotha|m
goulotte|f
governale|f
governante|f
grafema|m
grafiosi|f
grafite|f
grafoanalisi|f
gramma|m
grammaticaggine|f
grandine|f
granduca|m
granigione|f
granturismo|f
granulocita|m
granulocitopoiesi|f
granuloma|m
granuloplasma|m
granulopoiesi|f
granzima|m
gratitudine|f
griffe|f
grifosi|f
grisaille|f
grisoutite|f
grossularite|f
gru|f
grullaggine|f
grullagine|f
gualdo|f
guardacaccia|m
guardapalma|m
guardiamarina|m
guarigione|f
guarnigione|f
guepiere|f
guêpière|f
guernigione|f
gufaggine|f
guideline|f
gurge|f
hall|f
halloysite|f
hamada|m
handycam|f
hathayoga|m
helanca|m
hessonite|f
heta|m
hispanidad|f
holding|f
home|f
horeca|m
hostess|f
huebnerite|f
hübnerite|f
i|f
ialite|f
ialuronidasi|f
iatrogenesi|f
ibridoma|m
iconostasi|f
ideogramma|m
idioma|m
idradenite|f
idrargirite|f
idrartrosi|f
idraste|f
idratasi|f
idroclorotiazide|f
idrogenasi|f
idrogenolisi|f
idrolasi|f
idrolisi|f
idroma|m
idronefrosi|f
idrosadenite|f
idrosi|f
idrosoadenite|f
idrossiapatite|f
idrossibastnaesite|f
idrossibenzaldeide|f
idrossilasi|f
idrotassi|f
iente|f
igiene|f
ignorantaggine|f
ileite|f
illite|f
ilmenite|f
ilvaite|f
imago|f
imbandigione|f
imbecillaggine|f
imbotte|f
immagine|f
immago|f
immide|f
immondizie|f
immunocita|m
immunoliposoma|m
immunopoiesi|f
immunoprofilassi|f
impala|m
impasse|f
impetigine|f
impiccagione|f
improntitudine|f
incantagione|f
inchiestista|m
incude|f
incudine|f
indagine|f
indifferenziata|m
indigestione|f
indole|f
inettitudine|f
infante|f
infestante|f
infingardaggine|f
infowar|f
ingestione|f
inghalla|m
ingluvie|f
ingratitudine|f
iniziale|f
inquietudine|f
insetticida|m
insulinoma|m
insulsaggine|f
integrasi|f
intelligence|f
intemperie|f
intercapedine|f
intercinesi|f
interfase|f
interrete|f
intertrigine|f
intranet|f
inventione|f
invertasi|f
iole|f
ionoforesi|f
ionogramma|m
iota|m
ipallage|f
iperbole|f
ipercheratosi|f
ipercinesi|f
iperemesi|f
iperidrosi|f
ipermedia|m
ipermedicalizzazione|m
ipernefroma|m
iperostosi|f
iperperistalsi|f
iperstene|f
ipersuperficie|f
ipertecosi|f
ipertricosi|f
ipervitaminosi|f
ipnoanalisi|f
ipnosi|f
ipoazotide|f
ipobole|f
ipocicloide|f
ipocinesi|f
ipoderma|m
ipofisi|f
ipoglottide|f
ipoidrosi|f
ipomagma|m
iporchema|m
ipostasi|f
ipotassi|f
ipotesi|f
ipotiposi|f
ipotricosi|f
ipotrocoide|f
ipovitaminosi|f
ippiatra|m
ippomane|f
iprite|f
ipsilon|f
iradiddio|f
iride|f
iridociclite|f
iridodonesi|f
irite|f
irreligione|f
irrequietudine|f
isagoge|f
isbà|f
isoenzima|m
isogenesi|f
isomerasi|f
isoniazide|f
isostasi|f
isosuperficie|f
isteresi|f
istiocita|m
istogenesi|f
istogramma|m
istoplasmosi|f
istopoiesi|f
istrice|m
italiota|m
ittiosi|f
ittrite|f
jacobsite|f
jeep|f
jihad|f
julienne|f
kainite|f
kakatoa|m
kalaite|f
kallaite|f
kappa|m
karma|m
katiusha|m
katta|m
kea|m
kefiah|f
kefiyyah|f
kermesse|f
kilowattora|m
kimberlite|f
kinyarwanda|m
kippah|f
klockmannite|f
koala|m
kobret|f
koinè|f
kristiania|m
kuffyah|f
la|m
labiodentale|f
labiopalatale|f
labirintite|f
labirintosi|f
lady|f
lagostoma|m
lambda|m
lambliasi|f
lanciasagola|m
lanista|m
lanugine|f
lanugo|f
lapide|f
lapidificazione|m
larentalie|f
laringe|f
laringite|f
laringofaringite|f
laringostenosi|f
laringotracheite|f
larvicida|m
laterite|f
latitudine|f
lattamasi|f
lattasi|f
latterino|f
latticodeidrogenasi|f
lattogenesi|f
laude|f
lavadita|m
lavafrutta|m
lavamoquette|f
lavapiatti|f
lavastoviglie|f
lavatesta|m
lazulite|f
leadership|f
lecca-lecca|m
leccaciuffi|f
leccalecca|m
legge|f
legione|f
legionellosi|f
leishmaniosi|f
lemma|m
lentaggine|f
lente|f
lentiggine|f
leontiasi|f
lepade|f
lepidolite|f
lepisma|m
lepre|f
leptoclasi|f
leptomeninge|f
leptospirosi|f
lessema|m
lettere|f
leucocita|m
leucocitolisi|f
leucocitopoiesi|f
leucocitosi|f
leucoma|m
leucomielite|f
leucopoiesi|f
leucosi|f
levita|m
leziosaggine|f
libagione|f
libidine|f
libido|f
librettine|f
licnide|f
liddite|f
lidite|f
ligasi|f
lignificazione|m
ligninasi|f
lignite|f
lilla|m
lillà|f
limonite|f
lince|f
line|f
linfadenite|f
linfadenoma|m
linfadenosi|f
linfangite|f
linfedema|m
linfoadenite|f
linfoangite|f
linfocita|m
linfocitopoiesi|f
linfocitosi|f
linfogranuloma|m
linfoma|m
linfomonocitosi|f
linfopoiesi|f
linfosarcoma|m
linga|m
lingerie|f
linguamadre|f
linguolabiale|f
linguoversione|m
liparide|f
liparite|f
lipasi|f
lipedema|m
lipidosi|f
lipoadenoma|m
lipoedema|m
lipogenesi|f
lipogramma|m
lipolisi|f
lipoma|m
lipomatosi|f
lipoproteinlipasi|f
liposarcoma|m
liposclerosi|f
liposoma|m
lisciadorsi|f
liseuse|f
lisi|f
lisosoma|m
listeriosi|f
lite|f
litiasi|f
litoclasi|f
litodialisi|f
litogenesi|f
litolisi|f
litonefrosi|f
litosoma|m
litote|f
livornese|f
lobby|f
locomobile|f
lode|f
logogramma|m
lombaggine|f
longitudine|f
longuette|f
lordaggine|f
lordosi|f
luce|f
lucidalabbra|m
luciferasi|f
lue|f
lugana|m
lumenora|m
lunale|f
lungaggine|f
lungocosta|m
lungolinea|m
lungosenna|m
luogonatività|m
lupinosi|f
luteolisi|f
ma|m
maccabiade|f
maccha|m
macerie|f
macroanalisi|f
macrocita|m
macrocitosi|f
macroclima|m
macrogenesi|f
macroregione|f
macrosisma|m
macrosistema|m
macrospecie|f
macuba|m
madarosi|f
madera|m
madre|f
madrefede|f
madrevite|f
maestranze|f
magenta|m
maggiorante|f
magione|f
magma|m
magnaccia|m
magnesite|f
magnetar|f
magnetite|f
magnitudine|f
magnitudo|f
maialina|m
mail|f
maionese|f
maitresse|f
malacarne|f
malachite|f
malafede|f
malagestione|f
malasorte|f
malloreddus|f
malondialdeide|f
maltasi|f
mammà|f
mammasantissima|m
mammogramma|m
manaide|f
manche|f
mandala|m
manforte|f
manga|m
manganite|f
mangiauomini|f
manicure|f
manitù|m
mannite|f
mannosidasi|f
mannosidosi|f
mano|f
mansuetudine|f
mantide|f
maracaia|m
maragia|m
maranza|m
marasma|m
marcasite|f
marconigramma|m
mareogramma|m
marginalia|m
marmolite|f
marsala|m
marupa|m
mascotte|f
masoreta|m
mastite|f
mastocarcinoma|m
mastocita|m
mastoide|f
mastoidite|f
mastopessi|f
matcha|m
matinée|f
matre|f
maxi|f
maxitangente|f
mazama|m
meche|f
mèche|f
mediante|f
mediastinite|f
medulloblastoma|m
mefite|f
megacariocita|m
megalesie|f
megaloblastosi|f
megalopoli|f
megawattora|m
meharista|m
meiosi|f
melangola|m
melanocita|m
melanogenesi|f
melanoma|m
melanosi|f
melasma|m
melensaggine|f
mellite|f
mellonaggine|f
melodramma|m
menabrida|m
menaide|f
menarca|m
meninge|f
meningite|f
meningoencefalite|f
menostasi|f
mente|f
merce|f
mercé|f
mercede|f
meristema|m
merzé|f
merzede|f
mesalliance|f
mesciacqua|m
mesenchima|m
mesenterite|f
mesoderma|m
mesofase|f
mesoregione|f
mesosoma|m
mesotelioma|m
messe|f
messia|m
metabasi|f
metabole|f
metabolita|m
metaboloma|m
metacinnabarite|f
metafase|f
metafilassi|f
metafisi|f
metafonesi|f
metafrasi|f
metagenesi|f
metagenoma|m
metagramma|m
metaldeide|f
metalepsi|f
metalloproteasi|f
metalue|f
metamorfosi|f
metanalisi|f
metanogenesi|f
metanolisi|f
metaplasma|m
metasifilide|f
metastasi|f
metatesi|f
metempsicosi|f
meteorogramma|m
metessi|f
meticolosaggine|f
metilasi|f
metilesterasi|f
metilferasi|f
metiltransferasi|f
metrite|f
metropoli|f
metropolita|m
metrostenosi|f
mezzafede|f
mezzanave|f
mezzanotte|f
mezzemaniche|f
miasma|m
micetoma|m
micosi|f
microanalisi|f
microaneurisma|m
microbicida|m
microbioma|m
microcita|m
microcitosi|f
microclima|m
microemulsione|m
microfiche|f
microfotogramma|m
micropinocitosi|f
microprogramma|m
microregione|f
microsisma|m
microsistema|m
microsoma|m
microtrauma|m
microtrombosi|f
midollare|f
midriasi|f
mielite|f
mielocita|m
mieloma|m
mielosclerosi|f
mignonnette|f
millanta|m
millebolle|f
millimole|f
milonite|f
mimesi|f
mimodramma|m
minchionaggine|f
mindfulness|f
mineralogramma|m
minerogenesi|f
mini|f
minicar|f
minimosca|m
miniserie|f
minuziosaggine|f
miocardiosi|f
miocardite|f
miochinasi|f
miocita|m
miogenesi|f
miogramma|m
miolisi|f
mioma|m
mioressi|f
miorressi|f
miosclerosi|f
miosi|f
miosite|f
miosotide|f
miriade|f
mirride|f
mìsta|m
mistificazione|m
mistione|f
misurapioggia|m
mitologema|m
mitopoiesi|f
mitosi|f
mixedema|m
mixoma|m
mixomatosi|f
mixosarcoma|m
miyagawa|m
moa|m
moglie|f
moire|f
moksha|m
mole|f
molibdenite|f
molle|f
mollizie|f
molotov|f
moltitudine|f
monade|f
monarca|m
monema|m
moniliasi|f
monoamminossidasi|f
monocita|m
monocitopoiesi|f
monocitosi|f
monoclinale|f
monocotiledone|f
monogenesi|f
monogramma|m
mononucleosi|f
monoossigenasi|f
monotype|f
montacasca|m
montalettighe|f
montapanna|m
montmorillonite|f
moquette|f
morfema|m
morfofonema|m
morfogenesi|f
morfonema|m
morfosi|f
morfosintassi|f
morlacco|f
mortaista|m
morte|f
moschettiera|m
mosciame|f
mostramercato|f
motocampestre|f
motofalce|f
motonave|f
moxibustione|f
mucilaggine|f
mucillaggine|f
mucinasi|f
mucolipidosi|f
mucolisi|f
mucopolisaccarasi|f
mucopolisaccaridosi|f
mucoproteina|m
mucoviscidosi|f
mulaggine|f
multimedia|m
multinazionale|f
munizioni|f
muraglione|f
musarola|m
muscovite|f
musmè|f
mutaforma|m
mutagenesi|f
mutagione|f
mutande|f
myosotys|f
nabla|m
naftile|f
naftogenesi|f
naga|m
nagra|m
naiade|f
nanoanalisi|f
nanoarte|f
napoli|f
narcoanalisi|f
narcoipnosi|f
narcosi|f
nare|f
nari|f
narice|f
nasica|m
natriuresi|f
natrolite|f
navarca|m
nave|f
nave-faro|f
nazionale|f
ndr|f
neanide|f
nebride|f
necrobiosi|f
necrolisi|f
necropoli|f
necroptosi|f
necrormone|f
necrosi|f
nefrite|f
nefrocarcinoma|m
nefroide|f
nefrolitiasi|f
nefropessi|f
nefroptosi|f
nefrosclerosi|f
nefrosi|f
neghittaggine|f
negritudine|f
nematocida|m
nemesi|f
neoangiogenesi|f
neoglicogenesi|f
neoplasma|m
neostoma|m
nepente|f
nereide|f
neuraminidasi|f
neurassite|f
neurite|f
neuroanastomosi|f
neuroblastoma|m
neurodermite|f
neuroectoderma|m
neurofibromatosi|f
neuroimmagine|f
neuroipofisi|f
neurolue|f
neuroma|m
neuroprotesi|f
neurosi|f
neurosifilide|f
neve|f
nevrassite|f
nevrite|f
nevrosi|f
newsletter|f
niccolite|f
nicotinammide|f
ninfalide|f
ninfomane|f
ninfosi|f
ninja|m
nirvana|m
nitrobarite|f
nitrocarbammide|f
nitrogenasi|f
noa|m
nobilitade|f
nobilitate|f
nodrice|f
noesi|f
nomogramma|m
nomoteta|m
nonnaggine|f
nonnulla|m
nosogenesi|f
nosoparassita|m
notizie|f
notte|f
novitade|f
novitate|f
nozze|f
nuba|m
nube|f
nubile|f
nucleasi|f
nucleolemma|m
nucleosidasi|f
nucleosidefosforilasi|f
nucleosintesi|f
nucleosoma|m
nucleotidasi|f
nucleotidiltrasferasi|f
nudrice|f
nulla|m
nullaggine|f
nullaosta|m
nun|f
nundine|f
nuro|f
nursery|f
nuvol|f
o|f
oasi|f
ocaggine|f
ocotona|m
oculorinite|f
ode|f
odiosaggine|f
odontogenesi|f
offendicula|m
oficalce|f
ofiolite|f
ofite|f
oftalmite|f
oftalmodonesi|f
oinochoe|f
ojibwa|m
oligoartrite|f
oligodendrocita|m
oligodendroglioma|m
oligosaccaridosi|f
olimpiade|f
olivenite|f
oloenzima|m
ologenesi|f
ologramma|m
olpe|f
oltretomba|m
omega|m
omelette|f
omeomerie|f
omeosi|f
omeostasi|f
omocariosi|f
omogramma|m
omolisi|f
omomorfosi|f
omoplata|m
oncocercosi|f
oncocita|m
oncogenesi|f
oncosi|f
onfalite|f
onice|f
onicogrifosi|f
onicomicosi|f
onicorressi|f
onicosi|f
onissi|f
onlus|f
ononide|f
ontogenesi|f
oocisti|f
oocita|m
ooforite|f
oogenesi|f
openione|f
opinione|f
oplita|m
oppenione|f
oppinione|f
optogramma|m
orazion|f
orchide|f
orchidopessi|f
orchidoptosi|f
orchiopessi|f
orchipessi|f
orchite|f
oreade|f
organigramma|m
organogenesi|f
organogramma|m
origine|f
ormonogenesi|f
orneblendite|f
ornitosi|f
orobanche|f
orogenesi|f
orsaggine|f
ortesi|f
ortite|f
ortogenesi|f
ortopantomogramma|m
ortostata|m
osanna|m
oscillogramma|m
osmidrosi|f
osmosi|f
ospitante|f
ossedione|f
ossidasi|f
ossidione|f
ossidoreduttasi|f
ossiliquite|f
ossitaglio|f
ossiuriasi|f
osteite|f
osteoartrite|f
osteoartrosi|f
osteoblastoma|m
osteocita|m
osteoclasta|m
osteoclastogenesi|f
osteoclastoma|m
osteocondrite|f
osteocondroma|m
osteocondrosi|f
osteoderma|m
osteofibrosi|f
osteogenesi|f
osteolisi|f
osteoma|m
osteomielite|f
osteonecrosi|f
osteoperiostite|f
osteopetrosi|f
osteoporosi|f
osteopsatirosi|f
osteoradionecrosi|f
osteosarcoma|m
osteosclerosi|f
osteosintesi|f
ostpolitik|f
ostracoda|m
otite|f
otocisti|f
otoematoma|m
otomeningite|f
otorinolaringoiatra|m
otosclerosi|f
oubliette|f
ouverture|f
ovariocisti|f
ovarite|f
overdose|f
ovicida|m
ovocita|m
ovogenesi|f
oziosaggine|f
p.zza|m
paca|m
pace|f
pachiderma|m
pachimeninge|f
pachitene|f
padda|m
padeglione|f
padiglione|f
paganalie|f
pagone|f
paillette|f
palatale|f
palatite|f
palatogramma|m
palatoschisi|f
paleosuperficie|f
palestrita|m
palilie|f
palingenesi|f
pallabase|f
pallabbase|f
pallacanestro|f
pallaccanestro|f
pallacesto|f
pallalcesto|f
pallamano|f
pallamuro|f
pallanuoto|f
pallasfratto|f
pallavolo|f
pallavvolo|f
pallovale|f
palude|f
pama|m
panama|m
panartrite|f
pancreatite|f
panda|m
pandispagna|m
pangenesi|f
panne|f
pannicolite|f
panoftalmite|f
panorama|m
pansé|f
pantacalze|f
pantoptosi|f
panzé|f
papamobile|f
papilledema|m
papillite|f
papilloma|m
parabasi|f
parabiosi|f
parabrezza|m
paracentesi|f
paracera|m
paracinesi|f
paracistite|f
paracqua|m
paradenite|f
paradentite|f
paradentosi|f
paradigma|m
paradontite|f
paradontosi|f
parafernalia|m
parafiamma|m
parafimosi|f
parafrasi|f
paragenesi|f
paragoge|f
paraipotassi|f
paralessi|f
paralimpiade|f
paralisi|f
parallasse|f
parallelogramma|m
parametrite|f
paramorfosi|f
paranefrite|f
paraolimpiade|f
paraormone|f
paraparesi|f
parapioggia|m
parasartie|f
parasceve|f
paraschiena|m
parasintesi|f
parassita|m
parassiticida|m
parassitosi|f
paratasca|m
paratassi|f
paratiroide|f
pare|f
parenchima|m
parenesi|f
parentesi|f
paresi|f
parete|f
paria|m
parodontite|f
parodontosi|f
parossitonesi|f
parotide|f
parotite|f
parrocchiale|f
parte|f
partenogenesi|f
partigione|f
partoriente|f
parure|f
passamontagna|m
passapalle|f
passaparola|m
passaruota|m
passatella|m
passaverdura|m
passavia|m
passionista|m
pastellone|f
pasteurellosi|f
pata|m
patema|m
patente|f
paternale|f
patogenesi|f
patriarca|m
paturnie|f
pauperie|f
paviglione|f
peana|m
pece|f
pecoraggine|f
pecorame|f
pecorume|f
pectasi|f
pectide|f
pectinasi|f
pectinesterasi|f
pectolisi|f
pedantaggine|f
pederasta|m
pederosi|f
pediculosi|f
pedicure|f
pedogenesi|f
pegamoide|f
pegmatite|f
pelagione|f
pelioma|m
peliosi|f
pelle|f
peltasta|m
pelvi|f
penale|f
pendente|f
pendice|f
penice|f
penicillasi|f
penicillinasi|f
pensioneide|f
pentacrinite|f
pentade|f
pentagonite|f
pentagramma|m
pentaidroborite|f
pentalfa|m
pentapoli|f
pentaprisma|m
pentarca|m
pepsi|f
peptidasi|f
percentuale|f
percettore|f
perenne|f
perfezion|f
perfine|f
performance|f
periapside|f
periartrite|f
pericardite|f
pericondrite|f
pericope|f
periderma|m
periduodenite|f
periegesi|f
periegeta|m
perifrasi|f
perigastrite|f
perinevrite|f
periodontite|f
periostite|f
periplasma|m
perisperma|m
peristalsi|f
peristasi|f
peritonite|f
perizoma|m
perlagione|f
perlite|f
permanente|f
permeasi|f
permutazion|f
permutite|f
pernice|f
pernicie|f
pernizie|f
perossisoma|m
perovskite|f
perseidi|f
pertosse|f
pescagione|f
pescanoce|f
pescespada|m
pesone|f
pestapaglia|m
peste|f
pesticida|m
pet-therapy|f
petrogenesi|f
pettide|f
pettorale|f
pianoterra|m
piantaggine|f
piantagione|f
piastrinosi|f
piattitudine|f
piazzaforte|f
piccosaggine|f
picnosi|f
piedatterra|m
piegaciglia|m
pielite|f
pielogramma|m
pielonefrite|f
pieride|f
pietade|f
pietate|f
pieve|f
pigiama|m
pigiapigia|m
pigione|f
pignolaggine|f
pimelosi|f
pincerna|m
pinconaggine|f
pincone|f
pinguedine|f
pinite|f
pinocitosi|f
pintore|f
pioderma|m
piodermite|f
piogenesi|f
piombaggine|f
pionefrosi|f
piosalpinge|f
pioviggine|f
pipì|f
piralide|f
piramide|f
piranha|m
pirargirite|f
pirata|m
pirazinamide|f
pirite|f
pirla|m
pirofosfatasi|f
pirofosfochinasi|f
pirolisi|f
pirolusite|f
piromagma|m
piromorfite|f
piroplasmosi|f
pirosi|f
pirossenite|f
pischelletto|f
pisolite|f
pisside|f
pitaide|f
pitiriasi|f
pittogramma|m
placentite|f
planitudine|f
plaquette|f
plasma|m
plasmaferesi|f
plasmagene|f
plasmocita|m
plasmocitoma|m
plasmodesma|m
plasmolisi|f
plasmopoiesi|f
platelminta|m
platisma|m
playlist|f
plebe|f
pleiade|f
pleiocitosi|f
pleurite|f
pleurocentesi|f
pleuroperitonite|f
pleuropolmonite|f
pluriball|f
pluriclasse|f
pneumoconiosi|f
pneumonite|f
pochade|f
podestate|f
podoflemmatite|f
poema|m
poeta|m
poggiatesta|m
poichilocita|m
poichilocitosi|f
poiesi|f
polarogramma|m
polcinella|m
poliacrilammide|f
polialite|f
poliamide|f
poliaminossidasi|f
poliammide|f
poliangioite|f
poliarammide|f
poliarterite|f
poliartrite|f
polibasite|f
policondrite|f
polidimite|f
poligenesi|f
polihalite|f
poliimmide|f
polimerasi|f
polimiosite|f
polineurite|f
polinevrite|f
poliomielite|f
polipeptide|f
poliposi|f
polireme|f
poliribosoma|m
polisintesi|f
polisoma|m
politeama|m
pollinosi|f
polmonite|f
poltronaggine|f
poltronite|f
polve|f
polver|f
polvere|f
pomice|f
popeline|f
porfirite|f
poroadenite|f
portaamalgama|m
portabicicletta|m
portacarta|m
portachiatte|f
portacipria|m
portaerei|f
portaeromobili|f
portafango|f
portafortuna|m
portafrutta|m
portaidrovolanti|f
portaimpronta|m
portainsegna|m
portalampada|m
portamalgama|m
portamatita|m
portamiccia|m
portamina|m
portamusica|m
portaposta|m
portapunta|m
portascalmiera|m
portasfortuna|m
portaspada|m
portatessera|m
portauova|m
portinsegna|m
posacavi|f
posareti|f
posate|f
positio|f
postacelere|f
postalveolare|f
postcombustione|f
postdentale|f
postite|f
pouponniere|f
prana|m
prassi|f
prebarba|m
prece|f
prediale|f
predigestione|f
pregione|f
prelegge|f
premilitare|f
premistoffa|m
premistoppa|m
presidenziali|f
presistole|f
pressapaglia|m
pressazolle|f
presuntuosaggine|f
primaiola|m
primarie|f
primase|f
prisma|m
privacy|f
probitade|f
probitate|f
problema|m
proboscide|f
procariota|m
procaspasi|f
proclama|m
proclisi|f
proctite|f
proctotomia|m
produzine|f
proenzima|m
profase|f
profeta|m
profilassi|f
progenie|f
proginnasma|m
proglottide|f
prognosi|f
programma|m
prole|f
prolessi|f
proloco|f
proluvie|f
promemoria|m
promessione|m
prometafase|f
promissione|m
propaggine|f
propoli|f
proptosi|f
prorogatio|f
proscinèma|m
prosenchima|m
prosseneta|m
prostaferesi|f
prostatite|f
prostesi|f
protasi|f
proteasi|f
proteasoma|m
proteinasi|f
proteinchinasi|f
proteinogenesi|f
proteogenesi|f
proteolisi|f
proteoma|m
proteosintesi|f
protesi|f
protista|m
protoclasi|f
protoctista|m
protolisi|f
protome|f
protonema|m
protopianeta|m
protoplasma|m
protostoma|m
protozoa|m
protrombinasi|f
provigione|f
provvigione|f
provvisionale|f
provviste|f
pruderie|f
prurigine|f
psammite|f
psefite|f
pseudoartrosi|f
pseudoceloma|m
pseudocisti|f
pseudoepifragma|m
pseudomonade|f
pseudomorfosi|f
pseudoparalisi|f
psicanalisi|f
psiche|f
psicoanalisi|f
psicocinesi|f
psicodiagnosi|f
psicodramma|m
psicogenesi|f
psicogramma|m
psiconevrosi|f
psicoprofilassi|f
psicosi|f
psicosintesi|f
psilosi|f
psittacosi|f
psoriasi|f
pterilosi|f
ptilosi|f
ptosi|f
pubarca|m
pudende|f
pulce|f
pulcinella|m
pulcritudine|f
pulpite|f
puma|m
pupù|f
purgagione|f
putredine|f
putrilagine|f
qoppa|m
quadricorrente|f
quadrimoto|f
quadripotenziale|f
quadrireme|f
quagga|m
quarantott'ore|f
quarantottore|f
quarzite|f
quattroruote|f
quenya|m
querce|f
quercite|f
querelle|f
questione|f
quiete|f
quietudine|f
quindicennale|f
quinoa|m
quinquatrie|f
quinquereme|f
quistione|f
quokka|m
quotalite|f
rabdomiolisi|f
rabdomiosarcoma|m
rachicentesi|f
rachischisi|f
rachitide|f
radice|f
radicolite|f
radioanalisi|f
radiocinema|m
radiodermatite|f
radiodermite|f
radiodiagnosi|f
radiodramma|m
radioemittente|f
radiofoto|f
radiogramma|m
radiolisi|f
radiomobile|f
radionecrosi|f
radiopilota|m
radioricevente|f
radiorumore|f
radioscrivente|f
radiosorgente|f
radiotelegramma|m
radiotelescrivente|f
radiotelestampante|f
radiotrasmittente|f
rafide|f
ragade|f
ragga|m
ragion|f
ragione|f
randonnée|f
ranuncolale|f
raschera|m
rascione|f
ratio|f
rattenuta|m
ratticida|m
raucedine|f
ravaglione|f
realia|m
recentissime|f
reception|f
reclame|f
redentorista|m
redine|f
reduttasi|f
refrigerante|f
reggifiaccola|m
reggipancia|m
reggipiccozza|m
reggiposata|m
reggisella|m
reggispinta|m
reggitesta|m
regione|f
regolabarba|m
religione|f
remigante|f
reni|f
rentrée|f
replisoma|m
requie|f
restituzione|m
rete|f
reticolocita|m
retinite|f
retinoblastoma|m
retroabside|f
retroanalisi|f
retrobocca|m
retrobottega|m
retroterra|m
retrotrascrittasi|f
rettite|f
rettitudine|f
rettocolite|f
reuma|m
reversale|f
revertigine|f
riammissione|m
rianalisi|f
ribellazione|m
ribellione|f
ribolla|m
ribonucleasi|f
ribosoma|m
ribozima|m
ricaricabile|f
ricatteide|f
ricetrasmissione|m
rickettsiosi|f
ricombinasi|f
ridicolaggine|f
riduttasi|f
riempibottiglie|f
riformagione|f
riligione|f
rimalmezzo|f
rinfuse|f
rinite|f
rinofaringe|f
rinofaringite|f
rinolaringite|f
risintesi|f
risultante|f
ritidoma|m
ritrosaggine|f
riunione|f
robigalie|f
rocaggine|f
rocaille|f
rocca-fuoco|f
roccaforte|f
rodanasi|f
rodenticida|m
rodocrosite|f
romanzo-verità|m
romice|f
rompifiamma|m
rondine|f
rosalie|f
rotonave|f
rotondezza|m
roulette|f
roulotte|f
roulottopoli|f
routine|f
rovesciatore|f
rovinafamiglie|f
rubellazione|m
ruche|f
ruggine|f
rulotte|f
rulottopoli|f
rupe|f
rupicapra|m
rusticaggine|f
ruzzone|f
sabba|m
sabbiavolo|f
sabbion|f
sabbione|f
saccarasi|f
saccoleva|m
sacha|m
sacrista|m
sacroileite|f
sagrista|m
salagione|f
salamone|f
salgemma|m
salicilaldeide|f
salicilammide|f
salmonellosi|f
salopette|f
salpinge|f
salpingite|f
salsedine|f
salsuggine|f
saltimbocca|m
saluresi|f
salute|f
salvagione|f
salvagonna|m
salvaroba|m
salvavita|m
samarcanda|m
sandrona|m
santimoniale|f
santippe|f
saprofita|m
sapropelite|f
sarcoidosi|f
sarcoma|m
sarcopsillosi|f
sartie|f
sartù|m
sassella|m
sassolite|f
satana|m
satiriasi|f
satsuma|m
saudade|f
sbadataggine|f
sbalorditaggine|f
sbattiova|m
sbattiuova|m
sboccataggine|f
sbruffonaggine|f
scacciapensieri|f
scadenzario|f
scafoidite|f
scaldaacqua|m
scaldacqua|m
scapataggine|f
scapece|f
scapestrataggine|f
scapolaggine|f
scaturigine|f
scelleraggine|f
scellerataggine|f
scempiaggine|f
scempiataggine|f
scepsi|f
scerpa|m
scheelite|f
schema|m
schepsi|f
schifosaggine|f
schismena|m
schistosoma|m
schistosomiasi|f
schizogenesi|f
schwa|m
schwarzite|f
sciacma|m
sciacquabudella|m
sciacquadita|m
sciagurataggine|f
scialacquatrice|m
scialoadenite|f
sciattaggine|f
scimmiaggine|f
scimunitaggine|f
scintigramma|m
scioglilingua|m
scioperaggine|f
scioperataggine|f
scipitaggine|f
scisma|m
scitale|f
scleradenite|f
sclereide|f
sclerenchima|m
sclerite|f
scleroadenite|f
scleroblastema|m
sclerosi|f
scolapasta|m
scolarca|m
scolasticaggine|f
scoliasta|m
scoliosi|f
scomma|m
scomunicagione|f
scontrosaggine|f
scotoma|m
scramblasi|f
scria|m
scriba|m
scrofolosi|f
scrofulosi|f
scuotipaglia|m
scure|f
scurra|m
sdraio|f
secante|f
seccaggine|f
sede|f
segale|f
segaossa|m
segatronchi|f
seghife|f
segnavia|m
seigiorni|f
selce|f
selenite|f
selenoaldeide|f
selenosi|f
selice|f
semantema|m
sembianz|f
semblante|f
semente|f
semibreve|f
semiconsonante|f
semiellisse|f
semifinale|f
seminagione|f
seminoma|m
semiopoiesi|f
semiosi|f
semivocale|f
senettude|f
senettute|f
sensibile|f
sepiolite|f
sepsi|f
serie|f
serpe|f
serpigine|f
serraporta|m
servoscala|m
servosistema|m
sesamoidite|f
sessantennale|f
sete|f
setterosa|m
settireme|f
sfacciataggine|f
sfalerite|f
sferocitosi|f
sferulite|f
sfiaccolaggine|f
sfigmogramma|m
sfinge|f
sfingolipidosi|f
sfingomielinasi|f
sfrontataggine|f
sgarbataggine|f
sgraziataggine|f
sguaiataggine|f
shigellosi|f
shikra|m
sibilante|f
sicilitudine|f
sicofanta|m
sicopanta|m
sicosi|f
sicurauto|f
siderite|f
siderolite|f
siderosi|f
sienite|f
siepe|f
siepi|f
sieroanafilassi|f
sierodiagnosi|f
sieroprofilassi|f
sierosinovite|f
sifilide|f
sifiloderma|m
sifiloma|m
sigma|m
sigmoidite|f
significatione|f
silema|m
silfide|f
silice|f
silicosi|f
sillepsi|f
sillessi|f
sillimanite|f
silloge|f
siltite|f
silvite|f
simbiogenesi|f
simbiosi|f
similitudine|f
similpelle|f
similudine|f
simposiarca|m
sinalefe|f
sinallagma|m
sinapsi|f
sinartrosi|f
sinassi|f
sinchisi|f
sinclinale|f
sincondrosi|f
sincope|f
sincrasi|f
sinderesi|f
sindesi|f
sindesmosi|f
sindone|f
sindrome|f
sinecie|f
sineciosi|f
sineddoche|f
sinedrita|m
sineresi|f
sinesi|f
sinestesi|f
sinfisi|f
singenesi|f
singrafe|f
sinizesi|f
sinopsi|f
sinossi|f
sinostosi|f
sinoviale|f
sinovite|f
sintagma|m
sintasi|f
sintassi|f
sinteresi|f
sintesi|f
sintetasi|f
sintogramma|m
sinusite|f
sinusoide|f
siriarca|m
siriasi|f
siringe|f
sirte|f
sisma|m
sismogramma|m
sistema|m
sistole|f
sitatunga|m
sitcom|f
situagione|f
skincare|f
smectite|f
smemorataggine|f
smilace|f
smithsonite|f
smorzacandela|m
socialrete|f
socioanalisi|f
sociodramma|m
sociogenesi|f
sociogramma|m
sociorete|f
sodomita|m
sofisma|m
sofisticaggine|f
soirée|f
solfamide|f
solfatasi|f
solfimmide|f
solitudine|f
sollecitudine|f
soma|m
somaraggine|f
somatoplasma|m
somnosi|f
sonogramma|m
sopra|m
sopraddote|f
sopradominante|f
sopragiacca|m
sopraimbotte|f
sopraporta|m
soprapporta|m
sopraveste|f
sopravveste|f
soprimbotte|f
sordaggine|f
sorgente|f
sorte|f
sottoclasse|f
sottocoda|m
sottocoppa|m
sottodiagnosi|f
sottodirectory|f
sottodominante|f
sottofase|f
sottogiacca|m
sottogola|m
sottopalla|m
sottopancia|m
sottoparte|f
sottopentola|m
sottopezza|m
sottoproblema|m
sottoprogramma|m
sottorete|f
sottoscala|m
sottoscocca|m
sottosella|m
sottosistema|m
sottospecie|f
sottotema|m
sottoveste|f
soubrette|f
souplesse|f
sovracorrente|f
sovradiagnosi|f
sovradosaggio|f
sovrarrapresentazioni|f
spandicera|m
spandisabbia|m
sparachiodi|f
sparapunti|f
spargifiamma|m
spasmolisi|f
spazionave|f
specie|f
specie-specificità|m
spegnicalce|f
speme|f
spene|f
spensierataggine|f
sperma|m
spermatocita|m
spermatogenesi|f
spermicida|m
spermiogenesi|f
spermiogramma|m
spessitudine|f
spettrogramma|m
spezie|f
spiaggiavolo|f
spilogale|f
spinacristi|f
spingimerda|m
spirale|f
spiritosaggine|f
spirochetosi|f
splenite|f
splenopessi|f
spliceosoma|m
spondilite|f
spondilolisi|f
spondilolistesi|f
sporicida|m
sporogenesi|f
sporozoa|m
spremifrutta|m
sprue|f
sputafuoco|f
stafiloma|m
stagione|f
stalagmite|f
stalattite|f
stampante|f
stannite|f
star|f
starlet|f
stasi|f
statale|f
state|f
steatoepatite|f
steatonecrosi|f
steatosi|f
stefanite|f
steganalisi|f
stele|f
stemma|m
stendibiancheria|m
stenogramma|m
stenosi|f
stercoraride|f
stereocinesi|f
stereogramma|m
steroidogenesi|f
sterpe|f
stigma|m
stigmate|f
stilema|m
stiliaga|m
stilita|m
stimma|m
stimmate|f
stipsi|f
stirpe|f
stishovite|f
stolidaggine|f
stoma|m
stomatite|f
storditaggine|f
stoviglie|f
str.|f
stradale|f
strage|f
strampalataggine|f
stratagemma|m
stratiota|m
streptochinasi|f
strofe|f
stroma|m
stromatolita|m
stronzaggine|f
stronzianite|f
stupidaggine|f
sturnide|f
subanalisi|f
subecumene|f
subedema|m
subregione|f
subroutine|f
succinite|f
succursale|f
suffragazione|m
suggestione|f
sumerogramma|m
suor|f
suoro|f
superantigene|f
superfice|f
superficie|f
superfinale|f
supermoto|f
superpiuma|m
superspazio|f
superstar|f
suppellettile|f
suspense|f
svagataggine|f
sventataggine|f
svogliataggine|f
tabacosi|f
tabe|f
taboga|m
tachifilassi|f
tachipessi|f
tafettà|m
taffetà|m
taffettà|m
tagliacuce|f
tagliaerba|m
taglialegna|m
tagliapasta|m
tagliapizza|m
tagliasfoglia|m
tagliasiepe|f
tagliasiepi|f
tagliauova|m
tagma|m
tagmema|m
tagua|m
talidomide|f
talpicida|m
taltuza|m
tamandua|m
tamarice|f
tamburagione|f
tamerice|f
tamia|m
tanatoesteta|m
tanatosi|f
tanga|m
tangente|f
tangentoide|f
tangenziale|f
tantalite|f
tantra|m
tanzanite|f
tartar|f
tartare|f
tassagione|f
tassema|m
tatù|m
tautogramma|m
taxi-girl|f
tebaide|f
tefrite|f
telaistica|m
telecinesi|f
telediagnosi|f
teledialisi|f
teledramma|m
telefoto|f
telegestione|f
telegramma|m
teleprogramma|m
telescrivente|f
telestampante|f
teletrasmittente|f
telofase|f
telomerasi|f
temide|f
temperie|f
tempestate|f
tempura|m
tencione|f
tendicatena|m
tendicinghia|m
tendinite|f
tendopoli|f
teniasi|f
tenosinovite|f
tentredine|f
tenzone|f
teobroma|m
teorema|m
teoresi|f
teratogenesi|f
terawattora|m
teredine|f
terme|f
termite|f
termodiffusione|m
termoforesi|f
termogenesi|f
termogramma|m
termolisi|f
termoosmosi|f
terranoce|f
terranova|m
terrazzone|f
tesi|f
tesmoteta|m
testa-coda|m
testacoda|m
testardaggine|f
testuggine|f
teta|m
tetra|m
tetrade|f
tetradramma|m
tetraedrite|f
tetraggine|f
tetragramma|m
tetrarca|m
tettogenesi|f
tettonite|f
texture|f
theta|m
tiade|f
tiazina|m
tiflite|f
tigre|f
tiloma|m
timoma|m
timpanite|f
tioacetale|f
tioacetammide|f
tiocarbamide|f
tiocarbammide|f
tiouracile|f
tiracatena|m
tirammina|m
tiramolla|m
tirannide|f
tiremmolla|m
tireocita|m
tireosi|f
tireotossicosi|f
tiroide|f
tiroidite|f
tisi|f
titanite|f
titolante|f
tivù|f
tivvù|f
tmesi|f
toboga|m
toccasana|m
tocolisi|f
toilette|f
tomogramma|m
tonema|m
tonsillite|f
topicida|m
topoisomerasi|f
torà|f
toracentesi|f
toracocentesi|f
torcibudella|m
toreuta|m
torianite|f
torite|f
toroide|f
torpedine|f
torpedo|f
torre|f
tosaerba|m
tosse|f
tossicone|f
tossicosi|f
totiente|f
totò|f
tournée|f
toxoplasmosi|f
tracciaevento|f
tracheite|f
tracheobronchite|f
trachite|f
tracklist|f
tracoma|m
tradigione|f
trance|f
transaminasi|f
transamminasi|f
transcitosi|f
transcriptasi|f
transferasi|f
transgenesi|f
transglutaminasi|f
translocasi|f
transpeptidasi|f
trapezita|m
trappista|m
trascrittasi|f
trascrittoma|m
trascuraggine|f
trascurataggine|f
trasferasi|f
traslocasi|f
trasmittente|f
trauma|m
trave|f
traveggole|f
trematoda|m
tremolite|f
trevira|m
triade|f
triamide|f
triammide|f
tribù|f
trichiasi|f
trichinosi|f
tricocefalosi|f
tricofitosi|f
tricoma|m
tricoptilosi|f
tricosi|f
tridimite|f
trierarca|m
trigramma|m
trinciafoglia|m
trinciapaglia|m
tripanosi|f
tripanosoma|m
tripanosomiasi|f
trireme|f
trisma|m
tritaossa|m
tritapaglia|m
trocanterite|f
trofoneurosi|f
troiaggine|f
trombocita|m
trombocitosi|f
tromboflebite|f
trombogenesi|f
trombolisi|f
trombosi|f
tronista|m
troupe|f
trullaggine|f
tsavorite|f
tuberale|f
tubercolosi|f
turbonave|f
turboventola|m
turpitudine|f
tuttala|m
tuttocampista|m
tutù|m
u|f
uccellagione|f
ufomania|m
ulite|f
ulp|f
ulti|f
ultracondensatore|f
unciale|f
uni|f
uniforme|f
unione|f
universiade|f
universitade|f
universitate|f
uracile|f
uraninite|f
urbe|f
ureasi|f
ureterite|f
uretrite|f
uretropessi|f
uridililtrasferasi|f
uridiltransferasi|f
urochinasi|f
urogenesi|f
urogramma|m
urolitiasi|f
uropoiesi|f
ursigramma|m
ustascia|m
ustilagine|f
ustione|f
usucapione|f
uveite|f
uvulite|f
vaccinoprofilassi|f
vacuoma|m
vaffa|m
vagabondaggine|f
vaginalite|f
vaginite|f
vaglia|m
vaivoda|m
val|f
valle|f
valpolicella|m
valvolame|f
vamp|f
vangelista|m
vantagione|f
variabile|f
variante|f
varice|f
variente|f
vasculite|f
väyrynenite|f
vece|f
vedette|f
veneralie|f
venere|f
ventiquattrore|f
verdeterra|m
vergine|f
vermiculite|f
vernice|f
verseggiatore|f
verticale|f
vertigine|f
vertute|f
verve|f
vestale|f
veste|f
vettovaglie|f
vi|f
vibice|f
vibrogramma|m
vicemadre|f
vicissitudine|f
videoarte|f
videogramma|m
videopirata|m
videosistema|m
villanelle|f
villocentesi|f
viltade|f
vinalie|f
vinilite|f
vinilpelle|f
violle|f
vippame|f
virago|f
virginia|m
virogenesi|f
virosi|f
visceroptosi|f
visuale|f
vite|f
vitiligine|f
vladika|m
voce|f
voga|m
voivoda|m
volpe|f
voltacasacca|m
voltafaccia|m
voltaire|f
voltamperora|m
voltapasta|m
voragine|f
vorago|f
votaggine|f
vu|f
vulcanalie|f
vulvite|f
vulvovaginite|f
vuotaggine|f
wagnerite|f
wattora|m
wawa|m
webcam|f
willemite|f
wimpzilla|m
wolframite|f
wulfenite|f
wustite|f
wüstite|f
xantelasma|m
xantinaossidasi|f
xantoma|m
xantomatosi|f
xenobiosi|f
xenogenesi|f
xenoparassita|m
xeroderma|m
xeroradiogramma|m
xerosi|f
xilanasi|f
xilema|m
xilolite|f
yakisoba|m
yard|f
yoga|m
yprite|f
zanzaricida|m
zanzata|m
zappacavallo|f
zappaterra|m
zeccola|m
zeolite|f
zervanismo|f
zeta|m
zeugita|m
zeugma|m
zigoma|m
zigosi|f
zimasi|f
zitellaggine|f
zola|m
zooantroponosi|f
zoomorfosi|f
zoonosi|f
zooparassita|m
zooprofilassi|f
zoppa|m
zoppaggine|f
zoticaggine|f
zucconaggine|f
`;

const PLURAL_DATA = `abaco|abachi
abaptista|abaptisti
abaton|abata
abbacchio|abbacchi
abbaco|abbachi
abbaglio|abbaglii
abbaruffio|abbaruffii
abbassatoio|abbassatoi
abbeveratoio|abbeveratoi
abbigliatoio|abbigliatoi
abboccatoio|abboccatoi
abugida|abugidi
acanzio|acanzi
acaricida|acaricidi
acarodomazio|acarodomazi
acazio|acazi
accappatoio|accappatoi
accecatoio|accecatoi
accenditoio|accenditoi
acchiappatoio|acchiappatoi
acciaio|acciai
acciarpio|acciarpii
acciottolio|acciottolii
acciugaio|acciugai
accoppiatoio|accoppiatoi
accoratoio|accoratoi
accordicchio|accordicchi
acetaio|acetai
acquacotta|acquecotte
acquaforte|acqueforti
acquaio|acquai
acquasanta|acquesante
acquavita|acquaviti
acquavitaio|acquavitai
addebbiatura|addebbiaturi
addio|addii
adefago|adefaghi
adenocarcinoma|adenocarcinomi
adenoma|adenomi
adipocita|adipociti
adrenarca|adrenarchi
adroma|adromi
aerorimorchio|aerorimorchi
aeroservizio|aeroservizi
aerospazio|aerospazi
afagia|afage
affario|affarii
affastellio|affastellii
affibbiatoio|affibbiatoi
affilarasoio|affilarasoi
affilatoio|affilatoi
affondatoio|affondatoi
affumicatoio|affumicatoi
aficionado|aficionados
aforisma|aforismi
aggottatoio|aggottatoi
agguagliatoio|agguagliatoi
agliaio|agliai
agnellaio|agnellai
agoraio|agorai
agranulocita|agranulociti
agroecosistema|agroecosistemi
agrosistema|agrosistemi
agrostemma|agrostemmi
aiduco|aiduchi
aio|ai
alabastraio|alabastrai
alcol|alcoli
alesatoio|alesatoi
algia|algie
allargatoio|allargatoi
allergia|allergie
allisciatoio|allisciatoi
allucciolio|allucciolii
altoforno|altiforni
amalgama|amalgami
amartoblastoma|amartoblastomi
amartoma|amartomi
ameloblastoma|ameloblastomi
aminogramma|aminogrammi
ammazzatoio|ammazzatoi
ammostatoio|ammostatoi
anacoreta|anacoreti
anagramma|anagrammi
analita|analiti
anaplasma|anaplasmi
anasarca|anasarchi
anatema|anatemi
anchilostoma|anchilostomi
ancia|ancie
ancoraio|ancorai
anemogramma|anemogrammi
anergia|anergie
aneurisma|aneurismi
anfibraco|anfibrachi
angioedema|angioedemi
angiogramma|angiogrammi
angioma|angiomi
angiosarcoma|angiosarcomi
annaffiatoio|annaffiatoi
annaspio|annaspii
anno-uomo|anni-uomo
annunzio|annunzi
antibiogramma|antibiogrammi
antichistica|antichistice
antico|antichi
antipapa|antipapi
antiprisma|antiprismi
antiscialagogo|antiscialagoghi
antropopiteco|antropopitechi
apeliota|apelioti
apocizio|apocizi
apoenzima|apoenzimi
apoftegma|apoftegmi
apologo|apologhi
apoptosoma|apoptosomi
aporema|aporemi
apotema|apotemi
apozema|apozemi
apozeugma|apozeugmi
apozzema|apozzemi
appaltoconcorso|appalticoncorsi
appannatoio|appannatoi
apparecchio|apparecchi
appianatoio|appianatoi
appiccatoio|appiccatoi
appiombatoio|appiombatoi
appoggiatoio|appoggiatoi
apritoio|apritoi
arameogramma|arameogrammi
aranciaio|aranciai
arbëresh|arbëreshë
archeometallurgia|archeometallurgie
archettaio|archettai
archiatra|archiatri
archimandrita|archimandriti
arciduca|arciduchi
arcipelago|arcipelaghi
arcolaio|arcolai
areogramma|areogrammi
areopagita|areopagiti
areopago|areopaghi
argonauta|argonauti
armerista|armeristi
armistizio|armistizi
armocromia|armocromii
aroma|aromi
arpeggio|arpeggii
arrestatoio|arrestatoi
arridatoio|arridatoi
arrovellio|arrovellii
arruffio|arruffii
artefizio|artefizi
arteriogramma|arteriogrammi
artifizio|artifizi
artralgia|artralgie
asciugatoio|asciugatoi
asiarca|asiarchi
asinaio|asinai
aspatoio|aspatoi
assenzio|assenzi
assioma|assiomi
assonema|assonemi
assoplasma|assoplasmi
astio|asti
astrocita|astrociti
astucciaio|astucciai
ateroma|ateromi
atomistica|atomistice
attingitoio|attingitoi
attizzafuoco|attizzafuochi
attizzatoio|attizzatoi
audiogramma|audiogrammi
auriga|aurighi
autobruco|autobruchi
autofagolisosoma|autofagolisosomi
autofagosoma|autofagosomi
autoimpiego|autoimpieghi
autolisosoma|autolisosomi
automa|automi
autopilota|autopiloti
autoservizio|autoservizi
autosoma|autosomi
autospazio|autospazi
autotelaio|autotelai
avance|avances
aviosuperficie|aviosuperfici
avoltoio|avoltoi
avventizio|avventizi
avvio|avvii
avvocaticchio|avvocaticchi
avvoltoio|avvoltoi
babbomorto|babbimorti
babbucciaio|babbucciai
bacaio|bacai
baccellaio|baccellai
bacchio|bacchi
bacio|bacii
baco|bachi
bagagliaio|bagagliai
balaustio|balausti
balenio|balenii
balestraio|balestrai
ballatoio|ballatoi
baloccaio|baloccai
baluginio|baluginii
bambinaio|bambinai
bambocciaio|bambocciai
bandieraio|bandierai
bansigo|bansighi
barabba|barabbi
barasinga|barasinghi
barbatellaio|barbatellai
barbudo|barbudos
barcollio|barcollii
barilaio|barilai
barnabita|barnabiti
barocciaio|barocciai
barogramma|barogrammi
barrocciaio|barrocciai
basilico|basilichi
basolaio|basolai
bassilico|bassilichi
bassofondo|bassifondi
bassotuba|bassotubi
bastaio|bastai
batacchio|batacchi
batocchio|batocchi
batrachio|batrachi
batraco|batrachi
batracologia|baeracologie
battericida|battericidi
batteriodomazio|batteriodomazi
battezzatoio|battezzatoi
battilocchio|battilocchi
battitoio|battitoi
bavalischio|bavalischi
beccafico|beccafichi
beccaio|beccai
beccatoio|beccatoi
belladama|belledame
belladonna|belledonne
bellavista|belleviste
bendidio|bendidii
benefizio|benefizi
benzinaio|benzinai
berrettaio|berrettai
bestiaio|bestiai
beveratoio|beveratoi
bibliofagia|bibliofage
bigliettaio|bigliettai
bigliettinaio|bigliettinai
bilanciaio|bilanciai
biliardaio|biliardai
bimbaminkia|bimbeminkia
bimbominkia|bimbiminkia
binatoio|binatoi
bioenergia|bioenergie
bioinsetticida|bioinsetticidi
bioma|biomi
biometallurgia|biometallurgie
biopesticida|biopesticidi
biosistema|biosistemi
biribissaio|biribissai
birocciaio|birocciai
birracchio|birracchi
birraio|birrai
biscottaio|biscottai
bizzoco|bizzochi
blague|blagues
blanco|blancos
blastoderma|blastodermi
blastoma|blastomi
boccadopera|bocchedopera
boccaporta|boccaporti
bocciaio|bocciai
bollettinaio|bollettinai
boma|bomi
bombolaio|bombolai
borea|borei
borgogna|borgogni
borlonaio|borlonai
borsaio|borsai
borsettaio|borsettai
bottaio|bottai
bottegaio|bottegai
bottigliaio|bottigliai
bottinaio|bottinai
bottonaio|bottonai
boy|boys
bozzago|bozzaghi
bozzellaio|bozzellai
bozzolaio|bozzolai
brachialgia|brachialgie
brachiesofago|brachiesofaghi
braciaio|braciai
brago|braghi
brecciaio|brecciai
bretellaio|bretellai
brigidinaio|brigidinai
brillatoio|brillatoi
brillio|brillii
brio|brii
brividio|brividii
brodaio|brodai
bromoindaco|bromoindachi
broncogramma|broncogrammi
brontolio|brontolii
bruciataio|bruciatai
bruco|bruchi
brugo|brughi
brumaio|brumai
brunitoio|brunitoi
brusio|brusii
bue|buoi
bufalaio|bufalai
buio|bui
buleuta|buleuti
buonalana|buonelane
buonamano|buonemani
buongustaio|buongustai
buonuomo|buonuomini
burattinaio|burattinai
burchio|burchi
burraio|burrai
bussatoio|bussatoi
bustaio|bustai
buttafuoco|buttafuochi
buzzico|buzzichi
buzzolaio|buzzolai
cablogramma|cablogrammi
cacatoio|cacatoi
cacchio|cacchi
cacciapalla|cacciapalli
cacciatore-raccoglitore|cacciatori-raccoglitori
caciaio|caciai
caciocappella|caciocappelli
caco|cachi
cafaggiaio|cafaggiai
caiaco|caiachi
calamaio|calamai
calazio|calazi
calcatoio|calcatoi
calcinaio|calcinai
calciosoma|calciosomi
caldaio|caldai
caldarrostaio|caldarrostai
calderaio|calderai
callifugo|callifughi
calligramma|calligrammi
calosoma|calosomi
calzatoio|calzatoi
calzettaio|calzettai
calzolaio|calzolai
calzonaio|calzonai
camiciaio|camiciai
camiscia|camiscie
camosciaio|camosciai
campaio|campai
camposanto|campisanti
canaio|canai
canapaio|canapai
candelaio|candelai
canestraio|canestrai
cannaio|cannai
cannolicchio|cannolicchi
canovaio|canovai
capasanta|capesante
capecchio|capecchi
capoarma|capiarma
capocchio|capocchi
capoclan|capiclan
capoconvoglio|capiconvoglio
capocorda|capicorda
capocorso|capicorso
capocronaca|capicronaca
capodopera|capidopera
capofabbricato|capifabbricato
capofacchino|capifacchino
capofossi|capifossi
capofreddo|capifreddi
capogabbiere|capigabbiere
capogioco|capogiochi
capolettera|capilettera
capolinea|capilinea
capomanipolo|capimanipolo
capomissione|capimissione
capopagina|capipagina
capoparto|capiparto
caporonda|capironda
caposcala|capiscala
caposcarico|capiscarici
capotesta|capitesta
capotimoniere|capitimonieri
capovaccaio|capovaccai
cappalunga|cappelunghe
cappasanta|cappesante
cappellaio|cappellai
cappellinaio|cappellinai
capraio|caprai
caprareccia|caprareccie
caprifico|caprifichi
caprimulgo|caprimulgi
caprugginatoio|caprugginatoi
capsa|capsae
caramellaio|caramellai
carbocaina|carbocaini
carbonaio|carbonai
carbonchio|carbonchi
carcinoma|carcinomi
carciofaio|carciofai
cardialgia|cardialgie
cardiochirurgia|cardiochirurgie
cardiocita|cardiociti
cardiogramma|cardiogrammi
cardiomiocita|cardiomiociti
cardiopalma|cardiopalmi
cariaco|cariachi
cariogramma|cariogrammi
carioplasma|carioplasmi
carisma|carismi
carnaio|carnai
carnesecca|carnisecche
carotaio|carotai
carrettaio|carrettai
carrettonaio|carrettonai
carroponte|carriponte
carrozzaio|carrozzai
cartacarbone|cartecarbone
cartagloria|carteglorie
cartaio|cartai
cartamoneta|cartemonete
cartastraccia|cartestracce
cartasuga|cartesughe
cartogramma|cartogrammi
cartolaio|cartolai
cartolibraio|cartolibrai
casa-barca|case-barca
casaforte|caseforti
casamatta|casematte
cascinaio|cascinai
cassaforma|casseforme
cassaforte|casseforti
cassaio|cassai
cassapanca|cassepanche
castagnacciaio|castagnacciai
castagnaio|castagnai
castigo|castighi
castratoio|castratoi
catabolita|cataboliti
cataclisma|cataclismi
catadiottrica|catadiottrice
cataplasma|cataplasmi
catinaio|catinai
cavallaio|cavallai
cavallovapore|cavallivapore
cavicchio|cavicchi
cavigliatoio|cavigliatoi
cavobuono|cavibuoni
cavolaio|cavolai
ceco|cechi
cefalalgia|cefalalgie
cefalgia|cefalgie
cellaio|cellai
celoma|celomi
celta|celti
cenciaio|cenciai
ceneraio|cenerai
cenobiarca|cenobiarchi
cenobita|cenobiti
cenocita|cenociti
centiloquio|centiloqui
centinaio|centinaia
centocchio|centocchi
centonchio|centonchi
centrodestra|centrodestri
centrosinistra|centrosinistri
centrosoma|centrosomi
ceraio|cerai
cerazio|cerazi
cerchiaio|cerchiai
cerchio|cerchi
cercopiteco|cercopitechi
cerebrofagia|cerebrofage
cernecchio|cernecchi
cernicchio|cernicchi
cestaio|cestai
cestinaio|cestinai
cheratinocita|cheratinociti
cherco|cherci
cherema|cheremi
chiacchierio|chiacchierii
chiaritoio|chiaritoi
chiavaio|chiavai
chiliarca|chiliarchi
chiocciolaio|chiocciolai
chioccolio|chioccolii
chiodaio|chiodai
chirurgia|chirurgie
cialdonaio|cialdonai
ciambellaio|ciambellai
cianaio|cianai
ciazio|ciazi
ciberspazio|ciberspazi
cicalio|cicalii
ciclotema|ciclotemi
cieco|ciechi
cigolio|cigolii
ciliegiaio|ciliegiai
cilindraio|cilindrai
cimazio|cimazi
cimiciaio|cimiciai
cinedramma|cinedrammi
cinghio|cinghi
cioccolataio|cioccolatai
ciocia|cioce
cipollaio|cipollai
cistoadenoma|cistoadenomi
cistogramma|cistogrammi
cistoma|cistomi
citoplasma|citoplasmi
citosoma|citosomi
ciuccia|ciuccie
ciuco|ciuchi
cladogramma|cladogrammi
clima|climi
climb|climbs
clisma|clismi
cloasma|cloasmi
coanozoa|coanozoi
cobego|cobeghi
cocchio|cocchi
cocciaio|cocciai
cocomeraio|cocomerai
coenzima|coenzimi
cofanaio|cofanai
coitarca|coitarchi
colagogo|colagoghi
colangiocarcinoma|colangiocarcinomi
colatoio|colatoi
coledoco|coledochi
collenchima|collenchimi
colloquio|colloqui
collotorto|collitorti
colo|cola
colon|colones
coltellinaio|coltellinai
colugo|colughi
comizio|comizi
comma|commi
compositoio|compositoi
concezionista|concezionisti
conclavista|conclavisti
condiloma|condilomi
condrocita|condrociti
condroma|condromi
condrosarcoma|condrosarcomi
consorzio|consorzi
contraltista|contraltisti
contravaio|contravai
controdazio|controdazi
controfuoco|controfuochi
controgioco|controgiochi
contromarcia|contromarcie
contropappafico|contropappafichi
controtelaio|controtelai
controvaio|controvai
copeco|copechi
coperchio|coperchi
copertoio|copertoi
copricerchio|copricerchi
coprifuoco|coprifuochi
corago|coraghi
corallaio|corallai
cordaio|cordai
corego|coreghi
corinzio|corinzi
corista|coristi
corniciaio|corniciai
corridoio|corridoi
corsoio|corsoi
cosmorama|cosmorami
coxalgia|coxalgie
cravattaio|cravattai
crematoio|crematoi
crepidoma|crepidomi
criochirurgia|criochirurgie
criptogramma|criptogrammi
crisma|crismi
crisopazio|crisopazi
cristallaio|cristallai
crittogramma|crittogrammi
crocchio|crocchi
crocicchio|crocicchi
croco|crochi
croissant|croissants
cromatogramma|cromatogrammi
cromodinamica|cromodinamice
cromonema|cromonemi
cromosoma|cromosomi
cronema|cronemi
cronogramma|cronogrammi
cronoprogramma|cronoprogrammi
cronoprologo|cronoprologhi
cruralgia|cruralgie
cruscaio|cruscai
cubozoa|cubozoi
cucchiaio|cucchiai
culaco|culachi
cumenda|cumendi
cuoco|cuochi
cuoiaio|cuoiai
curandaio|curandai
cyberspazio|cyberspazi
dacrioma|dacriomi
dalmata|dalmati
danaio|danai
dappoco|dappochi
darmstadtio|darmstadti
darmstazio|darmstazi
dattilogramma|dattilogrammi
dazio|dazi
decagramma|decagrammi
decalogo|decaloghi
decanapulazione|decanapulazionie
decigramma|decigrammi
deliquio|deliqui
demagogo|demagoghi
dendrita|dendriti
dendrogramma|dendrogrammi
dépendance|dependanci
derma|dermi
dermatofita|dermatofiti
desio|desii
desmosoma|desmosomi
deuterostoma|deuterostomi
deviatoio|deviatoi
diadema|diademi
diadoco|diadochi
diaframma|diaframmi
diagramma|diagrammi
diastema|diastemi
diavolio|diavolii
diego|dieghi
difflugia|diffluge
digramma|digrammi
dilemma|dilemmi
dilitio|diliti
dimenio|dimenii
dimenticatoio|dimenticatoi
dinasta|dinasti
diniego|dinieghi
diorama|diorami
dipanatoio|dipanatoi
diploma|diplomi
dirimpettaio|dirimpettai
disbrigo|disbrighi
discarico|discarichi
disimpiego|disimpieghi
disio|disii
disobbligo|disobblighi
disservizio|disservizi
distenditoio|distenditoi
distillatoio|distillatoi
distoma|distomi
dittiosoma|dittiosomi
divano-letto|divani-letti
divincolio|divincolii
divorzio|divorzi
docciaio|docciai
dogma|dogmi
dogo|doghi
dolciera|dolcieri
dolico|dolichi
domazio|domazi
domineddio|domineddii
dondolio|dondolii
doppiosenso|doppisensi
doppiovetro|doppivetri
dorsalgia|dorsalgie
dossografia|dossografii
draco|drachi
drago|draghi
drammaturgia|drammaturgie
drink|drinks
duca|duchi
dugo|dughi
echinoderma|echinodermi
echio|echi
ecista|ecisti
ecocardiogramma|ecocardiogrammi
ecoclima|ecoclimi
ecogenetica|ecogenetice
ecogramma|ecogrammi
ecosistema|ecosistemi
ectoderma|ectodermi
ectoparassita|ectoparassiti
ectoplasma|ectoplasmi
eczema|eczemi
edema|edemi
edifizio|edifizi
effigie|effigi
elettrocardiogramma|elettrocardiogrammi
elettrochimica|elettrochimice
elettrochirurgia|elettrochirurgie
elettroencefalogramma|elettroencefalogrammi
elettroferogramma|elettroferogrammi
elettrolita|elettroliti
elettrometallurgia|elettrometallurgie
elettromiogramma|elettromiogrammi
elettrosiderurgia|elettrosiderurgie
elioenergia|elioenergie
eliogramma|eliogrammi
elisuperficie|elisuperfici
elminta|elminti
elmintagogo|elmintagoghi
elminticida|elminticidi
eloderma|elodermi
eloquio|eloqui
emagogo|emagoghi
emangioma|emangiomi
ematoma|ematomi
emblema|emblemi
emidesmosoma|emidesmosomi
emiparassita|emiparassiti
emistichio|emistichi
emmenagogo|emmenagoghi
emoangioma|emoangiomi
emoblastoma|emoblastomi
emoceloma|emocelomi
emopessina|emopessini
empiema|empiemi
enantema|enantemi
encefalogramma|encefalogrammi
encomiasta|encomiasti
encondroma|encondromi
endoderma|endodermi
endolinfa|endolinfi
endolisosoma|endolisosomi
endoparassita|endoparassiti
endoplasma|endoplasmi
endosoma|endosomi
endosperma|endospermi
endostio|endosti
endotelioma|endoteliomi
energia|energie
enfisema|enfisemi
engramma|engrammi
enigma|enigmi
enimma|enimmi
enneagramma|enneagrammi
enomotarca|enomotarchi
entactina|entactini
entandrofragma|entandrofragmi
enterocita|enterociti
enteroclisma|enteroclismi
entimema|entimemi
entomostraco|entomostrachi
enzima|enzimi
eparca|eparchi
epatocarcinoma|epatocarcinomi
epicherema|epicheremi
epifonema|epifonemi
epifragma|epifragmi
epiframma|epiframmi
epigastralgia|epigastralgie
epigenoma|epigenomi
epigramma|epigrammi
epilogo|epiloghi
epimagma|epimagmi
epirrema|epirremi
episoma|episomi
episperma|epispermi
epitelioma|epiteliomi
equinozio|equinozi
erbaio|erbai
erbicida|erbicidi
erbolaio|erbolai
ergastoplasma|ergastoplasmi
eritema|eritemi
eritrasma|eritrasmi
eritrocita|eritrociti
esagramma|esagrammi
esantema|esantemi
esarca|esarchi
eschio|eschi
esercizio|esercizi
esicasta|esicasti
esizio|esizi
esoderma|esodermi
esopianeta|esopianeti
esosoma|esosomi
essiccatoio|essiccatoi
essizio|essizi
estrusoma|estrusomi
eterocromosoma|eterocromosomi
eterofagia|eterofage
eterofagosoma|eterofagosomi
eterosoma|eterosomi
etra|etri
eucariota|eucarioti
eunuco|eunuchi
evangelista|evangelisti
fabula|fabulae
fagiolaio|fagiolai
fago|faghi
fagocita|fagociti
fagolisosoma|fagolisosomi
fagosoma|fagosomi
faio|fai
falsabraca|falsebrache
falsachiglia|falsechiglie
falsettista|falsettisti
falsotaglio|falsitagli
fanalaio|fanalai
fantasma|fantasmi
farinaio|farinai
farmacopea|farmacopei
fasciatoio|fasciatoi
fascinaio|fascinai
fatamorgana|fatemorgane
fattoio|fattoi
favellio|favellii
febbrifugo|febbrifughi
fecaio|fecai
fecaloma|fecalomi
fedifrago|fedifraghi
fellema|fellemi
felloderma|fellodermi
feltraio|feltrai
fenditoio|fenditoi
feocromocitoma|feocromocitomi
ferrivecchio|ferrivecchi
ferrovecchio|ferrovecchi
fiaccheraio|fiaccherai
fiammiferaio|fiammiferai
fiascaio|fiascai
fibbiaio|fibbiai
fibroma|fibromi
fibromialgia|fibromialgie
fibrosarcoma|fibrosarcomi
ficaio|ficai
fico|fichi
ficodindia|fichidindia
ficosecco|fichisecchi
figo|fighi
figulinaio|figulinai
figurinaio|figurinai
filatoio|filatoi
filosofema|filosofemi
finocchio|finocchi
fio|fii
fioraio|fiorai
fitoclima|fitoclimi
fitodomazio|fitodomazi
flare|flares
flash-back|flash-backs
flashback|flashbacks
floema|floemi
fluidodinamica|fluidodinamice
foco|fochi
focolaio|focolai
follatoio|follatoi
fondolago|fondilago
fondovalle|fondivalle
fonema|fonemi
fonocardiogramma|fonocardiogrammi
fonogramma|fonogrammi
foratoio|foratoi
forbiciaio|forbiciai
forchiaio|forchiai
formaggiaio|formaggiai
formicaio|formicai
formicolaio|formicolai
formicolio|formicolii
fornaciaio|fornaciai
fornaio|fornai
fortalizio|fortalizi
fortilizio|fortilizi
fotoallergia|fotoallergie
fotogramma|fotogrammi
fotomeccanica|fotomeccanice
fotoservizio|fotoservizi
fotosistema|fotosistemi
fragolaio|fragolai
frantoio|frantoi
frasaio|frasai
frego|freghi
fregolatoio|fregolatoi
frenaio|frenai
freno-motore|freni-motore
frimaio|frimai
frocia|froce
frondaio|frondai
frontespizio|frontespizi
frullio|frullii
fruscio|fruscii
fuco|fuchi
fulminio|fulminii
fumacchio|fumacchi
funaio|funai
fungicida|fungicidi
fusciacchio|fusciacchi
fustagnaio|fustagnai
gabbiaio|gabbiai
galantuomo|galantuomini
galattagogo|galattagoghi
galeopiteco|galeopitechi
gallinaio|gallinai
galoppatoio|galoppatoi
gambalaio|gambalai
gambasecca|gambesecche
gambecchio|gambecchi
gametocita|gametociti
gang|gangs
ganglioma|gangliomi
gastralgia|gastralgie
gattamorta|gattemorte
gattomammone|gattimammoni
geco|gechi
gelataio|gelatai
genoma|genomi
gentilizio|gentilizi
gentiluomo|gentiluomini
geocronometria|geocronometrii
gerarca|gerarchi
germicida|germicidi
germinatoio|germinatoi
germoplasma|germoplasmi
gessaio|gessai
gesticolio|gesticolii
ghiacciaio|ghiacciai
ghirlandaio|ghirlandai
giacchio|giacchi
giaco|giachi
giardinaio|giardinai
giliegia|giliege
ginepraio|gineprai
ginnasiarca|ginnasiarchi
giocattolaio|giocattolai
giogo|gioghi
giornalaio|giornalai
giostraio|giostrai
giramaschio|giramaschi
girio|girii
giropilota|giropiloti
girovago|girovaghi
giudio|giudii
giudizio|giudizi
giuoco|giuochi
giuraddio|giuraddii
glaciologa|glaciologe
glaucoma|glaucomi
glena|gleni
glicosoma|glicosomi
glioblastoma|glioblastomi
glioma|gliomi
gliossisoma|gliossisomi
glossema|glossemi
gocciolatoio|gocciolatoi
gocciolio|gocciolii
golfara|golfari
golia|golii
gomitiera|gomitieri
gommina|gommini
gonfiatoio|gonfiatoi
gorgoglio|gorgoglii
governicchio|governicchi
gracchio|gracchi
gracidio|gracidii
grafema|grafemi
graio|grai
gramma|grammi
grammo-atomo|grammi-atomo
grammo-equivalente|grammi-equivalenti
grammo-mole|grammi-moli
granaio|granai
granchiaio|granchiai
granchio|granchi
granduca|granduchi
granitoio|granitoi
granocchio|granocchi
granulocita|granulociti
granuloma|granulomi
granuloplasma|granuloplasmi
granzima|granzimi
grattatoio|grattatoi
gricia|grice
gridio|gridii
grisatoio|grisatoi
guaiaco|guaiachi
guaio|guai
guanaco|guanachi
guantaio|guantai
guardapalma|guardapalmi
guatemalteco|guatemaltechi
guerrafondaio|guerrafondai
heroon|heroa
hidalgo|hidalgos
homo|homini
huco|huchi
huomo|huomini
huovo|huova
ialurgia|ialurgie
ibridoma|ibridomi
iddio|iddii
ideogramma|ideogrammi
idioma|idiomi
idragogo|idragoghi
idrofugo|idrofughi
idrologa|idrologe
idroma|idromi
idromeccanica|idromeccanice
idrometallurgia|idrometallurgie
imbarcatoio|imbarcatoi
imbeccatoio|imbeccatoi
imbottatoio|imbottatoi
immondezzaio|immondezzai
immunocita|immunociti
immunoliposoma|immunoliposomi
impiego|impieghi
incannatoio|incannatoi
incarico|incarichi
incettatore|incettatoro
incubatoio|incubatoi
indaco|indachi
indifferenziata|indifferenziati
indizio|indizi
inferitoio|inferitoi
infortunistica|infortunistice
inghiottitoio|inghiottitoi
inginocchiatoio|inginocchiatoi
ingiusto|ingiusta
inizio|inizi
innaffiatoio|innaffiatoi
innestatoio|innestatoi
insalataio|insalatai
insetticida|insetticidi
insettifugo|insettifughi
insulinoma|insulinomi
internunzio|internunzi
interspazio|interspazi
interstizio|interstizi
intrico|intrichi
intrigo|intrighi
invio|invii
inzolfatoio|inzolfatoi
ioco|iochi
ionogramma|ionogrammi
ipanzio|ipanzi
ipercarica|ipercarice
ipernefroma|ipernefromi
iperspazio|iperspazi
ipersuperficie|ipersuperfici
ipoderma|ipodermi
ipomagma|ipomagmi
iporchema|iporchemi
ippiatra|ippiatri
ischialgia|ischialgie
ischio|ischi
islamistica|islamistice
isoenzima|isoenzimi
isosuperficie|isosuperfici
istiocita|istiociti
istogramma|istogrammi
italiota|italioti
kakatoa|kakatoi
kulak|kulaki
labro|labra
laco|lachi
lacrimatoio|lacrimatoi
lactagogo|lactagoghi
lagnio|lagnii
lagostoma|lagostomi
laminatoio|laminatoi
lampadinaio|lampadinai
lampanaio|lampanai
lampeggio|lampeggii
lampionaio|lampionai
lanciaio|lanciai
lanista|lanisti
lanternaio|lanternai
lapazio|lapazi
lardatoio|lardatoi
larvicida|larvicidi
laserchirurgia|laserchirurgie
lastraio|lastrai
laterizio|laterizi
latrinaio|latrinai
lattagogo|lattagoghi
lattaio|lattai
lattifugo|lattifughi
laurenzio|laurenzi
lavandaio|lavandai
lavatoio|lavatoi
lavorio|lavorii
lawrentio|lawrenti
leggio|leggii
leguleio|legulei
lemma|lemmi
lentischio|lentischi
lepisma|lepismi
lessema|lessemi
letamaio|letamai
letargia|letargie
leucocita|leucociti
leucoio|leucoi
leucoma|leucomi
levita|leviti
lezio|lezi
libraio|librai
licciaio|licciai
ligia|lige
limio|limii
limonaio|limonai
linaio|linai
linfadenoma|linfadenomi
linfagogo|linfagoghi
linfedema|linfedemi
linfocita|linfociti
linfogranuloma|linfogranulomi
linfoma|linfomi
linfosarcoma|linfosarcomi
linguaio|linguai
lipedema|lipedemi
lipoadenoma|lipoadenomi
lipoedema|lipoedemi
lipogramma|lipogrammi
lipoma|lipomi
liposarcoma|liposarcomi
liposoma|liposomi
lisciatoio|lisciatoi
lisosoma|lisosomi
litio|liti
litisconsorzio|litisconsorzi
litosoma|litosomi
liturgia|liturgie
liutaio|liutai
locago|locaghi
loco|lochi
locus|loci
lodolaio|lodolai
logogramma|logogrammi
logorio|logorii
lombalgia|lombalgie
lombosciatalgia|lombosciatalgie
lombricaio|lombricai
lombrico|lombrichi
loppaio|loppai
lubecchio|lubecchi
lucciolaio|lucciolai
lucciolio|lucciolii
lucernaio|lucernai
lucidatoio|lucidatoi
luco|luchi
lueco|luechi
luglienga|luglienge
lugo|lughi
lumaio|lumai
lumenora|lumenori
luminaio|luminai
luminio|luminii
lungocosta|lungocosti
lungolago|lungolaghi
lupinaio|lupinai
lupinellaio|lupinellai
lutezio|lutezi
macaco|macachi
maccheronaio|maccheronai
macellaio|macellai
maceratoio|maceratoi
macinatoio|macinatoi
macinio|macinii
macrocita|macrociti
macroclima|macroclimi
macrosisma|macrosismi
macrosistema|macrosistemi
madre-nonna|madri-nonne
magazine|magazines
magliaio|magliai
magma|magmi
magniloquio|magniloqui
mago|maghi
maialina|maialini
mainframe|mainframes
maiolicaio|maiolicai
malacopia|malecopie
malafede|malefedi
malalingua|malelingue
malaparola|maleparole
malaventura|maleventure
malcaduco|malcaduchi
maldocchio|maldocchi
malefizio|malefizi
maliscalcia|maliscalcie
malocchio|malocchi
mammogramma|mammogrammi
manager|managers
mancego|manceghi
mandracchio|mandracchi
maneggio|maneggii
manicaio|manicai
manticiaio|manticiai
manzolaio|manzolai
maracaia|maracai
marasma|marasmi
marchio|marchi
marcialonga|marcelonghe
marcitoio|marcitoi
marconigramma|marconigrammi
mareogramma|mareogrammi
marinaio|marinai
marmettaio|marmettai
marmocchio|marmocchi
marrucaio|marrucai
martellio|martellii
marxismo-leninismo|marxismi-leninismi
mascalcia|mascalcie
mascheraio|mascherai
maschio|maschi
maskio|maski
masoreta|masoreti
massaio|massai
mastalgia|mastalgie
mastellaio|mastellai
masticatoio|masticatoi
mastio|masti
mastocarcinoma|mastocarcinomi
mastocita|mastociti
mataco|matachi
materassaio|materassai
matitatoio|matitatoi
mattatoio|mattatoi
mattonaio|mattonai
mazzapicchio|mazzapicchi
mazzocchio|mazzocchi
medagliaio|medagliai
medicaio|medicai
mediogioco|mediogiochi
medulloblastoma|medulloblastomi
megabuco|megabuchi
megacariocita|megacariociti
megalobatraco|megalobatrachi
megaloeritema|megaloeritemie
megaron|megara
meharista|meharisti
meiopragia|meioprage
melacotogna|melecotogne
melangola|melangoli
melanocita|melanociti
melanoma|melanomi
melasma|melasmi
melodramma|melodrammi
melologo|melologhi
melonaio|melonai
menarca|menarchi
menatoio|menatoi
mendico|mendichi
merciaio|merciai
merdaio|merdai
meristema|meristemi
mescitoio|mescitoi
mescolio|mescolii
mesenchima|mesenchimi
mesoderma|mesodermi
mesosoma|mesosomi
mesotelioma|mesoteliomi
mestatoio|mestatoi
mestolaio|mestolai
metabolita|metaboliti
metaboloma|metabolomi
metagenoma|metagenomi
metagramma|metagrammi
metallurgia|metallurgie
metaplasma|metaplasmi
metatarsalgia|metatarsalgie
meteorogramma|meteorogrammi
metralgia|metralgie
metropolita|metropoliti
mezzacartuccia|mezzecartucce
mezzalana|mezzelane
mezzaluna|mezzelune
mezzanave|mezzenavi
mezzanotte|mezzenotti
mezzapugnetta|mezzepugnette
mezzapunta|mezzepunte
mezzasega|mezzeseghe
mezzatacca|mezzetacche
mezzatela|mezzetele
mezzatinta|mezzetinte
mezzocerchio|mezzocerchi
mezzocielo|mezzicieli
mezzomarinaio|mezzomarinai
mezzoservizio|mezzoservizi
miagolio|miagolii
mialgia|mialgie
miasma|miasmi
micetoma|micetomi
micodomazio|micodomazi
microaneurisma|microaneurismi
microbicida|microbicidi
microbioma|microbiomi
microchirurgia|microchirurgie
microcita|microciti
microclima|microclimi
microfotogramma|microfotogrammi
microprogramma|microprogrammi
microsisma|microsismi
microsistema|microsistemi
microsoma|microsomi
microtrauma|microtraumi
mielocita|mielociti
mieloma|mielomi
migliaio|migliaia
mignattaio|mignattai
miluogo|miluoghi
mimodramma|mimodrammi
mineralogramma|mineralogrammi
minestraio|minestrai
miocita|miociti
miogramma|miogrammi
mioma|miomi
miracolaio|miracolai
mirmecodomazio|mirmecodomazi
mischio|mischi
mìsta|mìsti
mistagogo|mistagoghi
mistico|mistichi
mitologema|mitologemi
mixedema|mixedemi
mixoma|mixomi
mixosarcoma|mixosarcomi
moco|mochi
moglie|mogli
molinaio|molinai
mollecchio|mollecchi
mollicchio|mollicchi
moltiloquio|moltiloqui
monarca|monarchi
mondatoio|mondatoi
mondezzaio|mondezzai
monema|monemi
monocita|monociti
monogramma|monogrammi
monologo|monologhi
montatoio|montatoi
morfema|morfemi
morfofonema|morfofonemi
morfonema|morfonemi
mormorio|mormorii
mortaio|mortai
mortaista|mortaisti
moscaio|moscai
moschettiera|moschettieri
mostacchio|mostacchi
mostramercato|mostremercato
moticchio|moticchi
motolancia|motolancie
mozzico|mozzichi
ms.|mss.
mucchio|mucchi
muchacha|muchachas
muchacho|muchachos
muco|muchi
mucoproteina|mucoproteini
mugnaio|mugnai
mugo|mughi
mulinaio|mulinai
multiloquio|multiloqui
mungitoio|mungitoi
muricciolaio|muricciolai
musarola|musaroli
muschio|muschi
mustacchio|mustacchi
nanochirurgia|nanochirurgie
nastraio|nastrai
nasturzio|nasturzi
natalizio|natalizi
naufrago|naufraghi
navarca|navarchi
nave-faro|navi-faro
navicellaio|navicellai
nefralgia|nefralgie
nefrocarcinoma|nefrocarcinomi
nefroplegia|nefroplege
nego|neghi
negozio|negozi
nematocida|nematocidi
neoplasma|neoplasmi
neostoma|neostomi
nettarasoio|nettarasoi
nettatoio|nettatoi
neuroblastoma|neuroblastomi
neurochirurgia|neurochirurgie
neuroectoderma|neuroectodermi
neuroma|neuromi
neuronofago|neuronofaghi
nevaio|nevai
nevischio|nevischi
nevralgia|nevralgie
niego|nieghi
nobiluomo|nobiluomini
nocchio|nocchi
nocciolaio|nocciolai
nocepesca|nocipesche
nomoteta|nomoteti
noodle|noodles
normoergia|normoergie
nosoparassita|nosoparassiti
nostalgia|nostalgie
notaio|notai
novellaio|novellai
novizio|novizi
nucleofugo|nucleofughi
nucleolemma|nucleolemmi
nucleosoma|nucleosomi
nunzio|nunzi
nuro|nure
obblio|obblii
oblio|oblii
occhialaio|occhialai
occhiellaio|occhiellai
occhio|occhi
occhiogrosso|occhigrossi
oco|ochi
ocotona|ocotoni
odontalgia|odontalgie
offizio|offizi
ofizio|ofizi
oligodendrocita|oligodendrociti
oligodendroglioma|oligodendrogliomi
olivaio|olivai
olmeco|olmechi
oloenzima|oloenzimi
ologramma|ologrammi
ombelico|ombelichi
ombellico|ombellichi
ombilico|ombilichi
ombrellaio|ombrellai
omo|omini
omogramma|omogrammi
omologo|omologhi
omoplata|omoplati
oncocita|oncociti
onestuomo|onestuomini
onfalorragia|onfalorrage
onomaturgia|onomaturgie
oocita|oociti
operaio|operai
oplita|opliti
optogramma|optogrammi
orbaco|orbachi
orciaio|orciai
orciolaio|orciolai
orditoio|orditoi
organaio|organai
organigramma|organigrammi
organogramma|organogrammi
organolitio|organoliti
orifizio|orifizi
orinatoio|orinatoi
oriolaio|oriolai
ornitischio|ornitischi
orologiaio|orologiai
orsacchio|orsacchi
orsoio|orsoi
orticaio|orticai
ortopantomogramma|ortopantomogrammi
ortostata|ortostati
oscillogramma|oscillogrammi
ospizio|ospizi
ossequio|ossequi
ossitocia|ossitoce
ossobuco|ossibuchi
ostealgia|ostealgie
osteoalgia|osteoalgie
osteoblastoma|osteoblastomi
osteocita|osteociti
osteoclasta|osteoclasti
osteoclastoma|osteoclastomi
osteocondroma|osteocondromi
osteoderma|osteodermi
osteoma|osteomi
osteosarcoma|osteosarcomi
ostio|osti
ostracoda|ostracodi
ostricaio|ostricai
otalgia|otalgie
otoematoma|otoematomi
ottonaio|ottonai
ovaio|ovai
ovarialgia|ovarialgie
ovicida|ovicidi
ovo|ova
ovocita|ovociti
ovolaio|ovolai
ozio|ozi
pacciugo|pacciughi
pachiderma|pachidermi
pacifondaio|pacifondai
paciugo|paciughi
paco|pachi
padellaio|padellai
pagliaio|pagliai
pago|paghi
palatogramma|palatogrammi
paleosuperficie|paleosuperfici
palestrita|palestriti
pallaio|pallai
pallonaio|pallonai
pallottolaio|pallottolai
palmizio|palmizi
pampalugo|pampalughi
pancrazio|pancrazi
panettaio|panettai
panico|panichi
panieraio|panierai
panorama|panorami
pantalonaio|pantalonai
pantofolaio|pantofolai
papeio|papei
papilledema|papilledemi
papilloma|papillomi
pappafico|pappafichi
paradenzio|paradenzi
paradigma|paradigmi
parago|paraghi
parallelogramma|parallelogrammi
paraocchio|paraocchi
parassita|parassiti
parassiticida|parassiticidi
parenchima|parenchimi
paretaio|paretai
parolaio|parolai
parruccaio|parruccai
partaccia|partaccie
pascialico|pascialichi
passatella|passatelli
passatoio|passatoi
passeraio|passerai
passerio|passerii
passionista|passionisti
pastafrolla|pastefrolle
pastaio|pastai
pastasciuttaio|pastasciuttai
pastrocchio|pastrocchi
pataracchio|pataracchi
patassio|patassii
patataio|patatai
patema|patemi
pateracchio|pateracchi
patriarca|patriarchi
patricidio|patricidii
patrizio|patrizi
pattinatoio|pattinatoi
pattonaio|pattonai
pattumaio|pattumai
pavesaio|pavesai
pecchiaio|pecchiai
pecoraio|pecorai
pedagogo|pedagoghi
pederasta|pederasti
pelago|pelaghi
pelatoio|pelatoi
pelioma|peliomi
pellaio|pellai
pellegrinaio|pellegrinai
pellicciaio|pellicciai
peltasta|peltasti
pemfigo|pemfighi
pencolio|pencolii
pendio|pendii
penfigo|penfighi
pennacchio|pennacchi
pennaio|pennai
pennecchio|pennecchi
pensatoio|pensatoi
pentabraco|pentabrachi
pentagramma|pentagrammi
pentaprisma|pentaprismi
pentarca|pentarchi
pentaspecchio|pentaspecchi
pentolaio|pentolai
peracottaio|peracottai
percotitoio|percotitoi
perianzio|perianzi
perichezio|perichezi
periderma|peridermi
periegeta|periegeti
periostio|periosti
periplasma|periplasmi
perisperma|perispermi
perizoma|perizomi
perlaio|perlai
perobrachio|perobrachi
perossisoma|perossisomi
pescanoce|peschenoci
pesceduovo|pesciduova
pescespada|pescispada
pesconoce|peschinoci
peso|pesos
pestatoio|pestatoi
pesticida|pesticidi
petacchio|petacchi
pettegolio|pettegolii
pettinaio|pettinai
pettinatoio|pettinatoi
pettinicchio|pettinicchi
pettobianco|pettibianchi
piagnucolio|piagnucolii
pianatoio|pianatoi
pianellaio|pianellai
piantatoio|piantatoi
piantonaio|piantonai
piastrellaio|piastrellai
piattaio|piattai
piazzaforte|piazzeforti
pidocchio|pidocchi
piego|pieghi
pielego|pieleghi
pielogramma|pielogrammi
pietraio|pietrai
pifferaio|pifferai
pigiama|pigiami
pigiatoio|pigiatoi
pignattaio|pignattai
pigo|pighi
pigolio|pigolii
pilatoio|pilatoi
pinax|pinakes
pincerna|pincerni
pinocchio|pinocchi
pioderma|piodermi
piombatoio|piombatoi
piovischio|piovischi
pipaio|pipai
pirata|pirati
pirla|pirli
piroelettrometallurgia|piroelettrometallurgie
piromagma|piromagmi
pirometallurgia|pirometallurgie
pirrichio|pirrichi
pisciatoio|pisciatoi
pisellaio|pisellai
pispiglio|pispiglii
pispolio|pispolii
pistacchio|pistacchi
pistrinaio|pistrinai
pittogramma|pittogrammi
piumaio|piumai
pizio|pizi
pizzico|pizzichi
plasma|plasmi
plasmocita|plasmociti
plasmocitoma|plasmocitomi
plasmodesma|plasmodesmi
platelminta|platelminti
platisma|platismi
plico|plichi
plugo|plughi
plumcake|plumcakes
podezio|podezi
poema|poemi
poeta|poeti
poichilocita|poichilociti
polarogramma|polarogrammi
polentaio|polentai
polimialgia|polimialgie
polipaio|polipai
poliribosoma|poliribosomi
polisoma|polisomi
politeama|politeami
pollaio|pollai
polveraio|polverai
polverio|polverii
pomaio|pomai
ponitoio|ponitoi
pontaio|pontai
pontonaio|pontonai
poponaio|poponai
poppatoio|poppatoi
porcaio|porcai
porchettaio|porchettai
porco|porci
porporaio|porporai
portafinestra|portefinestre
portascalmiera|portascalmieri
portego|porteghi
portenaio|portenai
porteria|porteri
portinaio|portinai
portonaio|portonai
posatoio|posatoi
positio|positiones
potatoio|potatoi
poveruomo|poveruomini
praio|prai
preannunzio|preannunzi
precarico|precarichi
precipizio|precipizi
precordialgia|precordialgie
precuoio|precuoi
prefazio|prefazi
pregiudizio|pregiudizi
prego|preghi
preincarico|preincarichi
preinizio|preinizi
prelio|prelia
prenunzio|prenunzi
prepuzio|prepuzi
prequoio|prequoi
pressoio|pressoi
prestinaio|prestinai
priego|prieghi
primadonna|primedonne
primaiola|primaioli
primanota|primenote
prisma|prismi
problema|problemi
proboviro|probiviri
procariota|procarioti
proclama|proclami
procoio|procoi
proctotomia|proctotomii
procuoio|procuoi
proenzima|proenzimi
profeta|profeti
profico|profichi
profilatoio|profilatoi
profiterole|profiteroles
profugo|profughi
proginnasma|proginnasmi
programma|programmi
prologo|prologhi
proloquio|proloqui
promezio|promezi
proquoio|proquoi
prosenchima|prosenchimi
prosseneta|prosseneti
proteasoma|proteasomi
proteoma|proteomi
protista|protisti
protobranchio|protobranchi
protoctista|protoctisti
protonema|protonemi
protonotaio|protonotai
protopianeta|protopianeti
protoplasma|protoplasmi
protostoma|protostomi
protozoa|protozoi
prunaio|prunai
pseudacacia|pseudacace
pseudanzio|pseudanzi
pseudoacacia|pseudacacie
pseudoceloma|pseudocelomi
pseudoepifragma|pseudoepifragmi
psicagogo|psicagoghi
psicochirurgia|psicochirurgie
psicodramma|psicodrammi
psicogramma|psicogrammi
psicolinguistica|psicolinguistice
psicopolitica|psicopolitice
pubalgia|pubalgie
pubarca|pubarchi
pulciaio|pulciai
pulcinaio|pulcinai
pungitoio|pungitoi
puntasecca|puntesecche
purificatoio|purificatoi
puttanaio|puttanai
quantum|quanta
quotalizio|quotalizi
rabdomiosarcoma|rabdomiosarcomi
rabocchio|rabocchi
racchio|racchi
rachialgia|rachialgie
radancia|radancie
radicchio|radicchi
radiochirurgia|radiochirurgie
radiodiagnostica|radiodiagnostice
radiodramma|radiodrammi
radiodrammaturgia|radiodrammaturgie
radioeco|radioechi
radiofarmacia|radiofarmace
radiogramma|radiogrammi
radiopilota|radiopiloti
radiotelegramma|radiotelegrammi
raffilatoio|raffilatoi
raffinatoio|raffinatoi
ragazza-copertina|ragazze-copertina
rago|raghi
ramaio|ramai
ramapiteco|ramapitechi
rammarico|rammarichi
rancho|ranchos
rancico|rancichi
ranocchiaio|ranocchiai
ranocchietta|ranocchietti
ranocchio|ranocchi
rantolio|rantolii
rapaio|rapai
raschiatoio|raschiatoi
rasoio|rasoi
raspatoio|raspatoi
raspio|raspii
rattenuta|rattenuti
ratticida|ratticidi
ravvio|ravvii
razzolio|razzolii
reality|realities
redancia|redancie
redentorista|redentoristi
reggifiaccola|reggifiaccoli
reggitoio|reggitoi
reimpiego|reimpieghi
reincarico|reincarichi
reinizio|reinizi
remaio|remai
renaio|renai
replisoma|replisomi
reticolocita|reticolociti
retinoblastoma|retinoblastomi
retrofrontespizio|retrofrontespizi
reuma|reumi
rhyton|rhytà
riavvio|riavvii
ribaditoio|ribaditoi
ribollio|ribollii
ribosoma|ribosomi
ribozima|ribozimi
ricciatoio|ricciatoi
ricottaio|ricottai
riepilogo|riepiloghi
rigo|righi
rimastico|rimastichi
rimbombio|rimbombii
rimenio|rimenii
rimescolio|rimescolii
rimorchio|rimorchi
rimpiego|rimpieghi
ringhio|ringhi
rinvio|rinvii
ripiego|ripieghi
rischio|rischi
risucchio|risucchi
ritidoma|ritidomi
ritorcitoio|ritorcitoi
rivoltolio|rivoltolii
rocca-fuoco|rocche-fuoco
rocchio|rocchi
rodenticida|rodenticidi
rodio|rodii
rogo|roghi
rollio|rollii
ronchio|ronchi
rondicchio|rondicchi
rosaio|rosai
rospaio|rospai
rotolio|rotolii
rotondezza|rotondezzi
rottamaio|rottamai
rovaio|rovai
rovinio|rovinii
rullio|rullii
rumorio|rumorii
ruzzolio|ruzzolii
sabbionaio|sabbionai
sacerdozio|sacerdozi
sacralgia|sacralgie
sacrifizio|sacrifizi
sacrista|sacristi
sago|saghi
sagrifizio|sagrifizi
sagrista|sagristi
saio|sai
salaccaio|salaccai
salatoio|salatoi
saldatoio|saldatoi
salinaio|salinai
salitoio|salitoi
salsicciaio|salsicciai
saltatoio|saltatoi
salumaio|salumai
salvadanaio|salvadanai
sambuco|sambuchi
sandrona|sandroni
santabarbara|santebarbare
santocchio|santocchi
saponaio|saponai
saprofita|saprofiti
saracchio|saracchi
sarago|saraghi
sarchio|sarchi
sarcoma|sarcomi
sarnacchio|sarnacchi
sassella|sasselli
sbaccanio|sbaccanii
sbadacchio|sbadacchi
sbaditoio|sbaditoi
sballottolio|sballottolii
sbalzellio|sbalzellii
sbarcatoio|sbarcatoi
sbatacchio|sbatacchi
sbattitoio|sbattitoi
sbieco|sbiechi
sbisorio|sbisorii
sbracalio|sbracalii
sbraciatoio|sbraciatoi
sbrego|sbreghi
scagnio|scagnii
scaldatoio|scaldatoi
scalpiccio|scalpiccii
scampanellio|scampanellii
scampanio|scampanii
scancia|scancie
scancio|scancii
scannatoio|scannatoi
scapecchiatoio|scapecchiatoi
scarabocchio|scarabocchi
scaracchio|scaracchi
scaricatoio|scaricatoi
scarico|scarichi
scarnatoio|scarnatoi
scarpaio|scarpai
scarrucolio|scarrucolii
scatenio|scatenii
scatolaio|scatolai
schema|schemi
schiancio|schiancii
schiaritoio|schiaritoi
schifio|schifii
schismena|schismeni
schistosoma|schistosomi
schiumatoio|schiumatoi
schizzatoio|schizzatoi
scia|scie
sciabordio|sciabordii
scialagogo|scialagoghi
scialofagia|scialofage
sciarbottatoio|sciarbottatoi
sciatalgia|sciatalgie
scimpanzuomo|scimpanzuomini
scintigramma|scintigrammi
scintillio|scintillii
sciocchezzaio|sciocchezzai
scioperio|scioperii
scisma|scismi
sciupinio|sciupinii
sciupio|sciupii
scivolio|scivolii
sclerenchima|sclerenchimi
scleroblastema|scleroblastemi
sclerozio|sclerozi
scodellaio|scodellai
scodinzolio|scodinzolii
scolaio|scolai
scolarca|scolarchi
scolatoio|scolatoi
scoliasta|scoliasti
scolmatoio|scolmatoi
scombussolio|scombussolii
scomma|scommi
scompiglio|scompiglii
scopaio|scopai
scorticatoio|scorticatoi
scotennatoio|scotennatoi
scotoma|scotomi
screzio|screzi
scria|scrii
scriba|scribi
scricchio|scricchi
scricchiolio|scricchiolii
scrittoio|scrittoi
scrocchio|scrocchi
scrollio|scrollii
scudaio|scudai
sculdascia|sculdascie
scuolaguida|scuoleguida
scuotitoio|scuotitoi
scurra|scurri
sdraio|sdraie
sdrucciolio|sdrucciolii
seccatoio|seccatoi
secchiaio|secchiai
secchio|secchi
secciaio|secciai
sediaio|sediai
seggiolaio|seggiolai
segnatoio|segnatoi
sego|seghi
selciaio|selciai
sellaio|sellai
semaio|semai
semantema|semantemi
semellaio|semellai
semenzaio|semenzai
semiala|semiali
semicerchio|semicerchi
semicuoio|semicuoi
semidio|semidii
seminatoio|seminatoi
seminio|seminii
seminoma|seminomi
semirimorchio|semirimorchi
semispazio|semispazi
senodochio|senodochi
sensaio|sensai
septuagenario|septuagenarii
serbatoio|serbatoi
serpaio|serpai
servizio|servizi
servosistema|servosistemi
sesterzio|sesterzi
setacciaio|setacciai
setolinaio|setolinai
sezzaio|sezzai
sfarfallio|sfarfallii
sfavillio|sfavillii
sfiatatoio|sfiatatoi
sfigmogramma|sfigmogrammi
sfizio|sfizi
sfogatoio|sfogatoi
sfogo|sfoghi
sfolgorio|sfolgorii
sfondagiaco|sfondagiachi
sfrigolio|sfrigolii
sgocciolatoio|sgocciolatoi
sgocciolio|sgocciolii
sgominio|sgominii
sgranatoio|sgranatoi
sgretolio|sgretolii
sguancio|sguancii
sibilio|sibilii
sicofanta|sicofanti
sicopanta|sicopanti
siderurgia|siderurgie
sifiloderma|sifilodermi
sifiloma|sifilomi
sigaraio|sigarai
silema|silemi
silenzio|silenzi
simposiarca|simposiarchi
sinallagma|sinallagmi
sincizio|sincizi
sindaco|sindaci
sinedrita|sinedriti
sinergia|sinergie
sintagma|sintagmi
sintogramma|sintogrammi
siriarca|siriarchi
sisma|sismi
sismogramma|sismogrammi
sistema|sistemi
sizio|sizi
smaltitoio|smaltitoi
smoccolatoio|smoccolatoi
snocciolatoio|snocciolatoi
sociodramma|sociodrammi
sociogramma|sociogrammi
sodalizio|sodalizi
sodomita|sodomiti
soffiatoio|soffiatoi
sofisma|sofismi
sogliaio|sogliai
solaio|solai
solecchio|solecchi
solicchio|solicchi
soliloquio|soliloqui
solletico|solletichi
solstizio|solstizi
somatoplasma|somatoplasmi
sonio|sonii
sonniloquio|sonniloqui
sonogramma|sonogrammi
sopraccarico|sopraccarichi
sopraddazio|sopraddazi
sopralluogo|sopralluoghi
sopraluogo|sopraluoghi
sopraporta|sopraporti
soprapporta|soprapporti
sopratonica|sopratonice
sornacchio|sornacchi
sotoportego|sotoporteghi
sottocoda|sottocodi
sottocuoco|sottocuochi
sottopalla|sottopalli
sottoportego|sottoporteghi
sottoproblema|sottoproblemi
sottoprogramma|sottoprogrammi
sottosistema|sottosistemi
sottospazio|sottospazi
sottotema|sottotemi
sottotonica|sottotonice
sovraccarico|sovraccarichi
sovraddazio|sovraddazi
spadaio|spadai
spagnaio|spagnai
spago|spaghi
spannocchio|spannocchi
spargifiamma|spargifiammi
spauracchio|spauracchi
spazio|spazi
spazio-tempo|spazi-tempo
spazzatoio|spazzatoi
spazzaturaio|spazzaturai
spazzolaio|spazzolai
specchiaio|specchiai
specchio|specchi
speco|spechi
spegnitoio|spegnitoi
sperma|spermi
spermatocita|spermatociti
spermazio|spermazi
spermicida|spermicidi
spermiogramma|spermiogrammi
sperperio|sperperii
spettrogramma|spettrogrammi
spianatoio|spianatoi
spicchio|spicchi
spicinio|spicinii
spigo|spighi
spillaio|spillai
spinacristi|spinecristi
spinaio|spinai
spingimerda|spingimerdi
spingitoio|spingitoi
splenalgia|splenalgie
spliceosoma|spliceosomi
spogliatoio|spogliatoi
spoiler|spoilers
spolverio|spolverii
sporicida|sporicidi
sporozoa|sporozoi
sposalizio|sposalizi
sprangaio|sprangai
spreco|sprechi
spremitoio|spremitoi
sproloquio|sproloqui
sputacchio|sputacchi
squartatoio|squartatoi
stacciaio|stacciai
staderaio|staderai
stafiloma|stafilomi
stagnaio|stagnai
starlet|starlets
stazio|stazi
stemma|stemmi
stenditoio|stenditoi
stenogramma|stenogrammi
stereociglio|stereociglia
stereogramma|stereogrammi
sterpaio|sterpai
stico|stichi
stilema|stilemi
stiliaga|stiliaghi
stilita|stiliti
stimma|stimmi
stipettaio|stipettai
stiratoio|stiratoi
stirotorcitoio|stirotorcitoi
stivalaio|stivalai
stoma|stomi
stomatorragia|stomatorrage
stovigliaio|stovigliai
straduccia|straduccie
strascico|strascichi
stratagemma|stratagemmi
stratego|strateghi
stratiota|stratioti
stravizio|stravizi
strazio|strazi
strettoio|strettoi
stridio|stridii
strimpellio|strimpellii
stringaio|stringai
stringitoio|stringitoi
strizzatoio|strizzatoi
strofinio|strofinii
stroma|stromi
stromatolita|stromatoliti
stucchinaio|stucchinai
subedema|subedemi
subspazio|subspazi
suco|suchi
sugheraio|sugherai
sugo|sughi
sumerogramma|sumerogrammi
superficie|superfici
supermaschio|supermaschi
superspazio|superspazi
superuomo|superuomini
supplizio|supplizi
sussiego|sussieghi
sussurrio|sussurrii
svago|svaghi
sventolio|sventolii
svettatoio|svettatoi
svio|svii
tabaccaio|tabaccai
tabula|tabulae
taco|tacos
tagicco|tagicci
tagma|tagmi
tagmema|tagmemi
tago|taghi
talpicida|talpicidi
tamburaio|tamburai
tanatoesteta|tanatoesteti
tappabuco|tappabuchi
tarassaco|tarassachi
tarsalgia|tarsalgie
tartufaio|tartufai
tassema|tassemi
taumaturgo|taumaturgi
taurotrago|taurotraghi
tautogramma|tautogrammi
tavernaio|tavernai
tecnezio|tecnezi
tecnopegnio|tecnopegnia
telaio|telai
telaistica|telaistichi
telechirurgia|telechirurgie
teledramma|teledrammi
telegramma|telegrammi
teleimpiego|teleimpieghi
teleprogramma|teleprogrammi
teleservizio|teleservizi
tenalgia|tenalgie
tenditoio|tenditoi
tenifugo|tenifughi
tentennio|tentennii
teobroma|teobromi
teorema|teoremi
termitaio|termitai
termogramma|termogrammi
teroldego|teroldeghi
terracotta|terrecotte
terraferma|terreferme
terranoce|terrenoci
teschio|teschi
tesmoteta|tesmoteti
tessutaio|tessutai
testacalda|testecalde
testucchio|testucchi
tetradramma|tetradrammi
tetragramma|tetragrammi
tetrarca|tetrarchi
teurgia|teurgie
tiazina|tiazini
ticchio|ticchi
tiloma|tilomi
timoma|timomi
tintinnio|tintinnii
tioalcol|tioalcoli
tirammina|tirammini
tirchio|tirchi
tireocita|tireociti
tirinzio|tirinzi
tizio|tizi
tolteco|toltechi
tomaio|tomai
tombacco|tombacci
tomogramma|tomogrammi
tonchio|tonchi
tonema|tonemi
topazio|topazi
topicida|topicidi
topos|topoi
torchio|torchi
torcitoio|torcitoi
tordaio|tordai
toreuta|toreuti
torronaio|torronai
tortaio|tortai
tossifugo|tossifughi
traballio|traballii
tracoma|tracomi
tramoggiaio|tramoggiai
trapanio|trapanii
trapezio|trapezi
trapezita|trapeziti
trapiantatoio|trapiantatoi
trappista|trappisti
trascrittoma|trascrittomi
trasloco|traslochi
trauma|traumi
trecciaio|trecciai
tremacchio|tremacchi
trematoda|trematodi
tremolio|tremolii
tribraco|tribrachi
tricheco|trichechi
tricoma|tricomi
trierarca|trierarchi
trifogliaio|trifogliai
trigramma|trigrammi
trimpellio|trimpellii
trinciatoio|trinciatoi
trio|trii
tripanosoma|tripanosomi
trippaio|trippai
trisma|trismi
trizio|trizi
troiaio|troiai
trombaio|trombai
trombocita|trombociti
tronista|tronisti
trottatoio|trottatoi
trotterellio|trotterellii
truciolaio|truciolai
turacciolaio|turacciolai
turbinio|turbinii
turpiloquio|turpiloqui
tuttocampista|tuttocampisti
uabaio|uabai
ubriaco|ubriachi
uccellaio|uccellai
uccellatoio|uccellatoi
uccellinaio|uccellinai
uffizio|uffizi
ufomania|ufomanii
uggiolio|uggiolii
ultramicrotomo|ultramicrotom1
umarell|umarells
unniloctio|unnilocti
unnilpentio|unnilpenti
unnilpenzio|unnilpenzi
unnilseptio|unnilsepti
ununhexio|ununhexi
ununoctio|ununocti
ununpentio|ununpenti
ununseptio|ununsepti
urecchio|urecchi
urinatoio|urinatoi
urlio|urlii
urofagia|urofage
urogramma|urogrammi
ursigramma|ursigrammi
usbeco|usbechi
ussoricidio|ussoricidii
usuraio|usurai
uxoricidio|uxoricidii
vaccaio|vaccai
vacuoma|vacuomi
vagellaio|vagellai
vago|vaghi
vaiaio|vaiai
vaio|vai
vaivoda|vaivodi
valentuomo|valentuomini
valicaio|valicai
valico|valichi
valigiaio|valigiai
vangelista|vangelisti
vaniloquio|vaniloqui
varego|vareghi
variago|variaghi
vasaio|vasai
vasellaio|vasellai
vassoio|vassoi
vecchio|vecchi
velaio|velai
vendemmiaio|vendemmiai
ventagliaio|ventagliai
ventricchio|ventricchi
ventriloquio|ventriloqui
vepraio|veprai
verdacchio|verdacchi
verdicchio|verdicchi
verduco|verduchi
verduraio|verdurai
vergaio|vergai
vermicaio|vermicai
vermifugo|vermifughi
verminaio|verminai
verrocchio|verrocchi
versatoio|versatoi
versiscioltaio|versiscioltai
versoio|versoi
veschio|veschi
vescia|vescie
vespaio|vespai
vetraio|vetrai
vetriciaio|vetriciai
vetrocromia|vetrocromihe
vetrofusione|vetrofusionie
viaccia|viaccie
vibrogramma|vibrogrammi
vico|vichi
videochirurgia|videochirurgie
videocolloquio|videocolloqui
videogioco|videogiochi
videogramma|videogrammi
videopirata|videopirati
videosistema|videosistemi
vilucchio|vilucchi
vinaio|vinai
vinchio|vinchi
violaio|violai
violinaio|violinai
viperaio|viperai
virago|viragini
vischio|vischi
vitalbaio|vitalbai
vitalizio|vitalizi
vitellaio|vitellai
viticchio|viticchi
vivaio|vivai
vizio|vizi
vociferio|vociferii
vocio|vocii
voivoda|voivodi
voltamaschio|voltamaschi
voltamperora|voltamperori
voltoio|voltoi
vorago|voraghi
vraccio|vraccia
vulnus|vulnera
xantelasma|xantelasmi
xantoma|xantomi
xenodochio|xenodochi
xenoparassita|xenoparassiti
xeroderma|xerodermi
xeroradiogramma|xeroradiogrammi
xilema|xilemi
yard|yards
zampillio|zampillii
zanaio|zanai
zanzaricida|zanzaricidi
zanzata|zanzati
zapoteco|zapotechi
zappacavallo|zappecavallo
zeccola|zeccoli
zeugita|zeugiti
zeugma|zeugmi
zigo|zighi
zigoma|zigomi
zimogramma|zimogrammi
zocchio|zocchi
zoccolaio|zoccolai
zolfaio|zolfai
zoodomazio|zoodomazi
zooparassita|zooparassiti
zoppa|zoppi
zuccaio|zuccai
zufolio|zufolii
zugo|zughi
`;

/** Nouns whose gender contradicts what their ending suggests. */
export const GENDERS: ReadonlyMap<string, "masculine" | "feminine"> = new Map(
  GENDER_DATA.split("\n")
    .filter((line) => line.length > 0)
    .map((line) => {
      const [lemma, gender] = line.split("|") as [string, string];
      return [lemma, gender === "f" ? "feminine" : "masculine"] as const;
    }),
);

/** Nouns whose plural the spelling rules do not produce. */
export const PLURALS: ReadonlyMap<string, string> = new Map(
  PLURAL_DATA.split("\n")
    .filter((line) => line.length > 0)
    .map((line) => line.split("|") as [string, string]),
);
